/* eslint-disable */ // Auto-generated file (DO NOT EDIT!!!), refer gql-codegen.yml

import { cacheExchange } from '@urql/exchange-graphcache';
import { Resolver as GraphCacheResolver, UpdateResolver as GraphCacheUpdateResolver, OptimisticMutationResolver as GraphCacheOptimisticMutationResolver } from '@urql/exchange-graphcache';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
};

export type CollectionReorderData = {
  __typename?: 'CollectionReorderData';
  /** Team Collection being moved */
  collection: TeamCollection;
  /** Team Collection succeeding the collection being moved in its new position */
  nextCollection?: Maybe<TeamCollection>;
};

export type CreateTeamRequestInput = {
  /** JSON string representing the request data */
  request: Scalars['String']['input'];
  /** ID of the team the collection belongs to */
  teamID: Scalars['ID']['input'];
  /** Displayed title of the request */
  title: Scalars['String']['input'];
};

export type InvitedUser = {
  __typename?: 'InvitedUser';
  /** Admin email of the admin who invited the user, NOTE: this value can be updated so may not be accurate */
  adminEmail: Scalars['String']['output'];
  /** Admin Name of the admin who invited the user, NOTE: this value can be updated so may not be accurate */
  adminName?: Maybe<Scalars['String']['output']>;
  /** Admin UID of the admin who invited the user */
  adminUid: Scalars['ID']['output'];
  /** invite ID */
  inviteID: Scalars['ID']['output'];
  /** Date when the user invitation was sent */
  invitedOn: Scalars['DateTime']['output'];
  /** Invitee email */
  inviteeEmail: Scalars['String']['output'];
  /** Org ID */
  orgID: Scalars['ID']['output'];
  /** Organization Name */
  orgName?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Accept an Organization Invite */
  acceptOrganizationInvitation: OrganizationMember;
  /** Accept an Invitation */
  acceptTeamInvitation: TeamMember;
  /** Create a new organization member. */
  addOrganizationMember: OrganizationMember;
  /**
   * Adds a team member to the team via email
   * @deprecated This is only present for backwards compatibility and will be removed soon use team invitations instead
   */
  addTeamMemberByEmail: TeamMember;
  /** Add a user to a team/workspace with email, org ID and team member role */
  addUserToTeamByAdmin: TeamMember;
  /** Cancel cloud for orgs subscription */
  cancelOrganizationSubscription: Scalars['Boolean']['output'];
  /** Create a collection that has a parent collection */
  createChildCollection: TeamCollection;
  /** Create a duplicate of an existing environment */
  createDuplicateEnvironment: TeamEnvironment;
  /** Create a request in the given collection. */
  createRequestInCollection: TeamRequest;
  /** Creates a collection at the root of the team hierarchy (no parent collection) */
  createRootCollection: TeamCollection;
  /** Create a shortcode for the given request. */
  createShortcode: Shortcode;
  /** Creates a team owned by the executing user */
  createTeam: Team;
  /** Creates an organization team by providing user UID to make OWNER */
  createTeamByAdmin: Team;
  /** Create a new Team Environment for given Team ID */
  createTeamEnvironment: TeamEnvironment;
  /** Creates a Team Invitation */
  createTeamInvitation: TeamInvitation;
  /** Deactivate an organization member */
  deactivateOrganizationMember: Scalars['Boolean']['output'];
  /** Delete all variables from a Team Environment */
  deleteAllVariablesFromTeamEnvironment: TeamEnvironment;
  /** Delete a collection */
  deleteCollection: Scalars['Boolean']['output'];
  /** Delete a request with the given ID */
  deleteRequest: Scalars['Boolean']['output'];
  /** Deletes the team */
  deleteTeam: Scalars['Boolean']['output'];
  /** Deletes an organization team by teamID */
  deleteTeamByAdmin: Scalars['Boolean']['output'];
  /** Delete a Team Environment for given Team ID */
  deleteTeamEnvironment: Scalars['Boolean']['output'];
  /** Delete an user account */
  deleteUser: Scalars['Boolean']['output'];
  /** Demote organization members who are admins */
  demoteOrganizationMembersAsAdmin: Scalars['Boolean']['output'];
  /** Duplicate a Team Collection */
  duplicateTeamCollection: Scalars['Boolean']['output'];
  /** Import collection from user firestore */
  importCollectionFromUserFirestore: TeamCollection;
  /** Import collections from JSON string to the specified Team */
  importCollectionsFromJSON: Scalars['Boolean']['output'];
  /** Initialize organization purchase flow. */
  initiateOrganizationPurchase: Scalars['String']['output'];
  /** Invite a user to the infra using email */
  inviteNewUser: InvitedUser;
  /** Leaves a team the executing user is a part of */
  leaveTeam: Scalars['Boolean']['output'];
  /** Make an organization member admin */
  makeOrganizationMemberAnAdmin: OrganizationMember;
  /** Make organization members admin */
  makeOrganizationMembersAdmin: Scalars['Boolean']['output'];
  /** Move a collection into a new parent collection or the root of the team */
  moveCollection: TeamCollection;
  /** Move a request to the given collection */
  moveRequest: TeamRequest;
  /** Remove a team member from an org team/workspace */
  removeMemberFromTeamByAdmin: Scalars['Boolean']['output'];
  /** Remove a member from an organization. */
  removeOrganizationMember: OrganizationMember;
  /** Removes the team member from the team */
  removeTeamMember: Scalars['Boolean']['output'];
  /**
   * Rename a collection
   * @deprecated Deprecated use `updateTeamCollection` mutation instead
   */
  renameCollection: TeamCollection;
  /** Renames a team */
  renameTeam: Team;
  /** Rename an organization team/workspace by teamID */
  renameTeamByAdmin: Team;
  /** Replace existing collections of a specific team with collections in JSON string */
  replaceCollectionsWithJSON: Scalars['Boolean']['output'];
  /** Remove an organization member as admin */
  revokeOrganizationMemberAdminAccess: OrganizationMember;
  /** Revoke organization member invites by invitee emails */
  revokeOrganizationMemberInvitationsByAdmin: Scalars['Boolean']['output'];
  /** Revokes an invitation and deletes it */
  revokeOrganizationTeamInviteByAdmin: Scalars['Boolean']['output'];
  /** Revoke a user generated shortcode */
  revokeShortcode: Scalars['Boolean']['output'];
  /** Revokes an invitation and deletes it */
  revokeTeamInvitation: Scalars['Boolean']['output'];
  /** Update the order of collections */
  updateCollectionOrder: Scalars['Boolean']['output'];
  /** Update a user generated Shortcode */
  updateEmbedProperties: Shortcode;
  /** Update the order of requests in the lookup table */
  updateLookUpRequestOrder: Scalars['Boolean']['output'];
  /** Update organization billing cycle. */
  updateOrganizationBillingCycle: Scalars['Boolean']['output'];
  /** Update organization seats. */
  updateOrganizationSeats: Scalars['Boolean']['output'];
  /** Update role of a team member in an org team/workspace */
  updateOrganizationTeamMemberRoleByAdmin: TeamMember;
  /** Update a request with the given ID */
  updateRequest: TeamRequest;
  /** Update Team Collection details */
  updateTeamCollection: TeamCollection;
  /** Add/Edit a single environment variable or variables to a Team Environment */
  updateTeamEnvironment: TeamEnvironment;
  /** Update role of a team member the executing user owns */
  updateTeamMemberRole: TeamMember;
};


export type MutationAcceptOrganizationInvitationArgs = {
  orgInviteID: Scalars['ID']['input'];
};


export type MutationAcceptTeamInvitationArgs = {
  inviteID: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAddOrganizationMemberArgs = {
  orgID: Scalars['ID']['input'];
  userUID: Scalars['ID']['input'];
};


export type MutationAddTeamMemberByEmailArgs = {
  teamID: Scalars['ID']['input'];
  userEmail: Scalars['String']['input'];
  userRole: TeamMemberRole;
};


export type MutationAddUserToTeamByAdminArgs = {
  orgID: Scalars['ID']['input'];
  teamID: Scalars['ID']['input'];
  userEmail: Scalars['ID']['input'];
  userRole: TeamMemberRole;
};


export type MutationCancelOrganizationSubscriptionArgs = {
  orgID: Scalars['ID']['input'];
};


export type MutationCreateChildCollectionArgs = {
  childTitle: Scalars['String']['input'];
  collectionID: Scalars['ID']['input'];
  data?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateDuplicateEnvironmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateRequestInCollectionArgs = {
  collectionID: Scalars['ID']['input'];
  data: CreateTeamRequestInput;
};


export type MutationCreateRootCollectionArgs = {
  data?: InputMaybe<Scalars['String']['input']>;
  teamID: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationCreateShortcodeArgs = {
  orgID?: InputMaybe<Scalars['ID']['input']>;
  properties?: InputMaybe<Scalars['String']['input']>;
  request: Scalars['String']['input'];
};


export type MutationCreateTeamArgs = {
  name: Scalars['String']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateTeamByAdminArgs = {
  name: Scalars['String']['input'];
  orgID: Scalars['ID']['input'];
  userUid: Scalars['ID']['input'];
};


export type MutationCreateTeamEnvironmentArgs = {
  name: Scalars['String']['input'];
  teamID: Scalars['ID']['input'];
  variables: Scalars['String']['input'];
};


export type MutationCreateTeamInvitationArgs = {
  inviteeEmail: Scalars['String']['input'];
  inviteeRole: TeamMemberRole;
  orgID?: InputMaybe<Scalars['ID']['input']>;
  teamID: Scalars['ID']['input'];
};


export type MutationDeactivateOrganizationMemberArgs = {
  orgID: Scalars['ID']['input'];
  orgMemberID: Scalars['ID']['input'];
};


export type MutationDeleteAllVariablesFromTeamEnvironmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCollectionArgs = {
  collectionID: Scalars['ID']['input'];
};


export type MutationDeleteRequestArgs = {
  requestID: Scalars['ID']['input'];
};


export type MutationDeleteTeamArgs = {
  teamID: Scalars['ID']['input'];
};


export type MutationDeleteTeamByAdminArgs = {
  orgID: Scalars['ID']['input'];
  teamID: Scalars['ID']['input'];
};


export type MutationDeleteTeamEnvironmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDemoteOrganizationMembersAsAdminArgs = {
  orgID: Scalars['ID']['input'];
  userUIDs: Array<Scalars['ID']['input']>;
};


export type MutationDuplicateTeamCollectionArgs = {
  collectionID: Scalars['String']['input'];
};


export type MutationImportCollectionFromUserFirestoreArgs = {
  fbCollectionPath: Scalars['String']['input'];
  parentCollectionID?: InputMaybe<Scalars['ID']['input']>;
  teamID: Scalars['ID']['input'];
};


export type MutationImportCollectionsFromJsonArgs = {
  jsonString: Scalars['String']['input'];
  parentCollectionID?: InputMaybe<Scalars['ID']['input']>;
  teamID: Scalars['ID']['input'];
};


export type MutationInitiateOrganizationPurchaseArgs = {
  organizationBillingCycle: OrganizationBillingCycle;
  organizationDomain: Scalars['String']['input'];
  organizationMetadata?: InputMaybe<Scalars['String']['input']>;
  organizationName: Scalars['String']['input'];
  organizationSeats: Scalars['Float']['input'];
};


export type MutationInviteNewUserArgs = {
  inviteeEmail: Scalars['String']['input'];
  orgID: Scalars['ID']['input'];
};


export type MutationLeaveTeamArgs = {
  teamID: Scalars['ID']['input'];
};


export type MutationMakeOrganizationMemberAnAdminArgs = {
  orgID: Scalars['ID']['input'];
  orgMemberID: Scalars['ID']['input'];
};


export type MutationMakeOrganizationMembersAdminArgs = {
  orgID: Scalars['ID']['input'];
  userUIDs: Array<Scalars['ID']['input']>;
};


export type MutationMoveCollectionArgs = {
  collectionID: Scalars['ID']['input'];
  parentCollectionID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationMoveRequestArgs = {
  destCollID: Scalars['ID']['input'];
  requestID: Scalars['ID']['input'];
};


export type MutationRemoveMemberFromTeamByAdminArgs = {
  orgID: Scalars['ID']['input'];
  teamID: Scalars['ID']['input'];
  userUid: Scalars['ID']['input'];
};


export type MutationRemoveOrganizationMemberArgs = {
  orgID: Scalars['ID']['input'];
  orgMemberID: Scalars['ID']['input'];
};


export type MutationRemoveTeamMemberArgs = {
  teamID: Scalars['ID']['input'];
  userUid: Scalars['ID']['input'];
};


export type MutationRenameCollectionArgs = {
  collectionID: Scalars['ID']['input'];
  newTitle: Scalars['String']['input'];
};


export type MutationRenameTeamArgs = {
  newName: Scalars['String']['input'];
  teamID: Scalars['ID']['input'];
};


export type MutationRenameTeamByAdminArgs = {
  newTeamName: Scalars['String']['input'];
  orgID: Scalars['ID']['input'];
  teamID: Scalars['ID']['input'];
};


export type MutationReplaceCollectionsWithJsonArgs = {
  jsonString: Scalars['String']['input'];
  parentCollectionID?: InputMaybe<Scalars['ID']['input']>;
  teamID: Scalars['ID']['input'];
};


export type MutationRevokeOrganizationMemberAdminAccessArgs = {
  orgID: Scalars['ID']['input'];
  orgMemberID: Scalars['ID']['input'];
};


export type MutationRevokeOrganizationMemberInvitationsByAdminArgs = {
  inviteeEmails: Array<Scalars['String']['input']>;
  orgID: Scalars['ID']['input'];
};


export type MutationRevokeOrganizationTeamInviteByAdminArgs = {
  inviteID: Scalars['ID']['input'];
  orgID: Scalars['ID']['input'];
};


export type MutationRevokeShortcodeArgs = {
  code: Scalars['ID']['input'];
};


export type MutationRevokeTeamInvitationArgs = {
  inviteID: Scalars['ID']['input'];
};


export type MutationUpdateCollectionOrderArgs = {
  collectionID: Scalars['ID']['input'];
  destCollID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateEmbedPropertiesArgs = {
  code: Scalars['ID']['input'];
  properties: Scalars['String']['input'];
};


export type MutationUpdateLookUpRequestOrderArgs = {
  collectionID: Scalars['ID']['input'];
  nextRequestID?: InputMaybe<Scalars['ID']['input']>;
  requestID: Scalars['ID']['input'];
};


export type MutationUpdateOrganizationBillingCycleArgs = {
  orgBillingCycle: OrganizationBillingCycle;
  orgID: Scalars['ID']['input'];
};


export type MutationUpdateOrganizationSeatsArgs = {
  orgID: Scalars['ID']['input'];
  seats: Scalars['Float']['input'];
};


export type MutationUpdateOrganizationTeamMemberRoleByAdminArgs = {
  newRole: TeamMemberRole;
  orgID: Scalars['ID']['input'];
  teamID: Scalars['ID']['input'];
  userUid: Scalars['ID']['input'];
};


export type MutationUpdateRequestArgs = {
  data: UpdateTeamRequestInput;
  requestID: Scalars['ID']['input'];
};


export type MutationUpdateTeamCollectionArgs = {
  collectionID: Scalars['ID']['input'];
  data?: InputMaybe<Scalars['String']['input']>;
  newTitle?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateTeamEnvironmentArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  variables: Scalars['String']['input'];
};


export type MutationUpdateTeamMemberRoleArgs = {
  newRole: TeamMemberRole;
  teamID: Scalars['ID']['input'];
  userUid: Scalars['ID']['input'];
};

export type Organization = {
  __typename?: 'Organization';
  /** The organization billing address */
  billingAddress?: Maybe<OrganizationBillingAddress>;
  /** The billing cycle opted for */
  billingCycle?: Maybe<OrganizationBillingCycle>;
  /** The organization billing email */
  billingEmail?: Maybe<Scalars['String']['output']>;
  /** Stripe checkout session URL */
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  /** Timestamp of when the organization was created */
  createdOn: Scalars['DateTime']['output'];
  /** The current organization billing end date */
  nextBillingDate?: Maybe<Scalars['Float']['output']>;
  /** The domain of the organization */
  orgDomain: Scalars['String']['output'];
  /** The organization ID */
  orgID: Scalars['ID']['output'];
  /** JSON string representing the metadata of the organization */
  orgMetadata?: Maybe<Scalars['String']['output']>;
  /** The name of the organization */
  orgName: Scalars['String']['output'];
  /** The organization subscription status */
  orgStatus: OrganizationStatus;
  /** The number of seats available in the organization */
  seats: Scalars['Float']['output'];
};

export type OrganizationBillingAddress = {
  __typename?: 'OrganizationBillingAddress';
  /** The city of the billing address */
  city?: Maybe<Scalars['String']['output']>;
  /** The country of the billing address */
  country?: Maybe<Scalars['String']['output']>;
  /** The first line of the billing address */
  line1?: Maybe<Scalars['String']['output']>;
  /** The second line of the billing address */
  line2?: Maybe<Scalars['String']['output']>;
  /** The postal code of the billing address */
  postal_code?: Maybe<Scalars['String']['output']>;
  /** The state of the billing address */
  state?: Maybe<Scalars['String']['output']>;
};

export enum OrganizationBillingCycle {
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY'
}

export type OrganizationMember = {
  __typename?: 'OrganizationMember';
  /** Timestamp of when the user was created */
  createdOn: Scalars['DateTime']['output'];
  /** Organization member ID */
  id: Scalars['ID']['output'];
  /** Timestamp of when the member was invited */
  invitedOn: Scalars['DateTime']['output'];
  /** The UID of the user who invited this member (doesn`t apply to the first member) */
  inviteeUserUID?: Maybe<Scalars['ID']['output']>;
  /** Indicates if the member is an admin */
  isAdmin: Scalars['Boolean']['output'];
  /** Timestamp of when the member was last active */
  lastActiveOn: Scalars['DateTime']['output'];
  /** Active status of the member in the given organization */
  membershipStatus: OrganizationMembershipStatus;
  /** The organization ID the member belongs to */
  orgID: Scalars['String']['output'];
  /** URL to the profile photo of the user (if fetched) */
  photoURL?: Maybe<Scalars['String']['output']>;
  /** The user email of the organization member (if fetched) */
  userEmail?: Maybe<Scalars['String']['output']>;
  /** The username of the organization member (if fetched) */
  userName?: Maybe<Scalars['String']['output']>;
  /** The user UID of the organization member */
  userUID: Scalars['String']['output'];
};

export enum OrganizationMembershipStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum OrganizationStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Inactive = 'INACTIVE'
}

export type Query = {
  __typename?: 'Query';
  /** Get a collection with the given ID or null (if not exists) */
  collection?: Maybe<TeamCollection>;
  /**
   * Returns the collections of the team
   * @deprecated Deprecated because of no practical use. Use `rootCollectionsOfTeam` instead.
   */
  collectionsOfTeam: Array<TeamCollection>;
  /** Returns the JSON string giving the collections and their contents of the team */
  exportCollectionsToJSON: Scalars['String']['output'];
  /** Returns an `InvitedUser` with additional org info based on a valid organization invite id */
  getOrgInviteDetails: InvitedUser;
  /** Returns the invited members details in an organization */
  invitedOrganizationMembers: Array<InvitedUser>;
  /** Gives details of the user executing this query (pass Authorization 'Bearer' header) */
  me: User;
  /** List all shortcodes the current user has generated */
  myShortcodes: Array<Shortcode>;
  /** List of teams that the executing user belongs to. */
  myTeams: Array<Team>;
  /** Returns the organization info */
  organization: Organization;
  /** Returns the organization ID by resolving org domain */
  organizationByDomain: Scalars['String']['output'];
  /** Returns the organization member details */
  organizationMember: OrganizationMember;
  /** Returns the organization members */
  organizationMembers: Array<OrganizationMember>;
  /** Returns member count in an organization */
  organizationMembersCount: Scalars['Float']['output'];
  /** Returns team collections count in an organization */
  organizationTeamCollectionsCount: Scalars['Float']['output'];
  /** Returns org team/workspace detail */
  organizationTeamInfo: Team;
  /** Returns team requests count in an organization */
  organizationTeamRequestsCount: Scalars['Float']['output'];
  /** Returns the teams/workspaces in an organization */
  organizationTeams: Array<Team>;
  /** Returns teams count in an organization */
  organizationTeamsCount: Scalars['Float']['output'];
  /** Gives a request with the given ID or null (if not exists) */
  request?: Maybe<TeamRequest>;
  /** Gives a list of requests in the collection */
  requestsInCollection: Array<TeamRequest>;
  /** Returns the collections of the team */
  rootCollectionsOfTeam: Array<TeamCollection>;
  /** Search the team for a specific request with title */
  searchForRequest: Array<TeamRequest>;
  /** Resolves and returns a shortcode data */
  shortcode?: Maybe<Shortcode>;
  /** Returns the detail of the team with the given ID */
  team?: Maybe<Team>;
  /** Gets the Team Invitation with the given ID, or null if not exists */
  teamInvitation: TeamInvitation;
  /**
   * Finds a user by their UID or null if no match
   * @deprecated Deprecated due to privacy concerns. Try to get the user from the context-relevant queries
   */
  user?: Maybe<User>;
};


export type QueryCollectionArgs = {
  collectionID: Scalars['ID']['input'];
};


export type QueryCollectionsOfTeamArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  teamID: Scalars['ID']['input'];
};


export type QueryExportCollectionsToJsonArgs = {
  teamID: Scalars['ID']['input'];
};


export type QueryGetOrgInviteDetailsArgs = {
  inviteID: Scalars['ID']['input'];
};


export type QueryInvitedOrganizationMembersArgs = {
  orgID: Scalars['ID']['input'];
};


export type QueryMyShortcodesArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryMyTeamsArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOrganizationArgs = {
  orgID: Scalars['ID']['input'];
};


export type QueryOrganizationByDomainArgs = {
  orgDomain: Scalars['ID']['input'];
};


export type QueryOrganizationMemberArgs = {
  orgID: Scalars['ID']['input'];
  orgMemberID: Scalars['ID']['input'];
};


export type QueryOrganizationMembersArgs = {
  orgID: Scalars['ID']['input'];
};


export type QueryOrganizationMembersCountArgs = {
  orgID: Scalars['ID']['input'];
};


export type QueryOrganizationTeamCollectionsCountArgs = {
  orgID: Scalars['ID']['input'];
};


export type QueryOrganizationTeamInfoArgs = {
  orgID: Scalars['ID']['input'];
  teamID: Scalars['ID']['input'];
};


export type QueryOrganizationTeamRequestsCountArgs = {
  orgID: Scalars['ID']['input'];
};


export type QueryOrganizationTeamsArgs = {
  orgID: Scalars['ID']['input'];
};


export type QueryOrganizationTeamsCountArgs = {
  orgID: Scalars['ID']['input'];
};


export type QueryRequestArgs = {
  requestID: Scalars['ID']['input'];
};


export type QueryRequestsInCollectionArgs = {
  collectionID: Scalars['ID']['input'];
  cursor?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRootCollectionsOfTeamArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  teamID: Scalars['ID']['input'];
};


export type QuerySearchForRequestArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  searchTerm: Scalars['String']['input'];
  teamID: Scalars['ID']['input'];
};


export type QueryShortcodeArgs = {
  code: Scalars['ID']['input'];
};


export type QueryTeamArgs = {
  teamID: Scalars['ID']['input'];
};


export type QueryTeamInvitationArgs = {
  inviteID: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserArgs = {
  uid: Scalars['ID']['input'];
};

export type RequestReorderData = {
  __typename?: 'RequestReorderData';
  /** Team Request succeeding the request being moved in its new position */
  nextRequest?: Maybe<TeamRequest>;
  /** Team Request being moved */
  request: TeamRequest;
};

export type Shortcode = {
  __typename?: 'Shortcode';
  /** Timestamp of when the Shortcode was created */
  createdOn: Scalars['DateTime']['output'];
  /** The 12 digit alphanumeric code */
  id: Scalars['ID']['output'];
  /** Organization ID */
  orgID?: Maybe<Scalars['String']['output']>;
  /** JSON string representing the properties for an embed */
  properties?: Maybe<Scalars['String']['output']>;
  /** JSON string representing the request data */
  request: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Listen to when a collections position has changed */
  collectionOrderUpdated: CollectionReorderData;
  /** Listen for shortcode creation */
  myShortcodesCreated: Shortcode;
  /** Listen for shortcode deletion */
  myShortcodesRevoked: Shortcode;
  /** Listen for Shortcode updates */
  myShortcodesUpdated: Shortcode;
  /** Listen for organization creation event following payment completion */
  organizationCreated: Scalars['String']['output'];
  /** Listen to when a new org member is added to an organization */
  organizationMemberAdded: OrganizationMember;
  /** Listen to when a org member is removed from an organization */
  organizationMemberRemoved: OrganizationMember;
  /** Emitted when a request has been moved from one collection into another */
  requestMoved: TeamRequest;
  /** Emitted when a requests position has been changed in its collection */
  requestOrderUpdated: RequestReorderData;
  /** Listen to when a collection has been added to a team. The emitted value is the team added */
  teamCollectionAdded: TeamCollection;
  /** Listen to when a collection has been moved */
  teamCollectionMoved: TeamCollection;
  /** Listen to when a collection has been removed */
  teamCollectionRemoved: Scalars['ID']['output'];
  /** Listen to when a collection has been updated. */
  teamCollectionUpdated: TeamCollection;
  /** Listen for Team Environment Creation Messages */
  teamEnvironmentCreated: TeamEnvironment;
  /** Listen for Team Environment Deletion Messages */
  teamEnvironmentDeleted: TeamEnvironment;
  /** Listen for Team Environment Updates */
  teamEnvironmentUpdated: TeamEnvironment;
  /** Listens to when a Team Invitation is added */
  teamInvitationAdded: TeamInvitation;
  /** Listens to when a Team Invitation is removed */
  teamInvitationRemoved: Scalars['ID']['output'];
  /** Listen to when a new team member being added to the team. The emitted value is the new team member added. */
  teamMemberAdded: TeamMember;
  /** Listen to when a team member has been removed. The emitted value is the uid of the user removed */
  teamMemberRemoved: Scalars['ID']['output'];
  /** Listen to when a team member status has been updated. The emitted value is the new team member status */
  teamMemberUpdated: TeamMember;
  /** Emits when a new request is added to a team */
  teamRequestAdded: TeamRequest;
  /** Emitted when a request has been deleted. Only the id of the request is emitted. */
  teamRequestDeleted: Scalars['ID']['output'];
  /** Emitted when a request has been updated */
  teamRequestUpdated: TeamRequest;
  /** Listen for user deletion */
  userDeleted: User;
  /** Listen for Organization user invitation */
  userInvited: InvitedUser;
};


export type SubscriptionCollectionOrderUpdatedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionOrganizationMemberAddedArgs = {
  orgID: Scalars['ID']['input'];
};


export type SubscriptionOrganizationMemberRemovedArgs = {
  orgID: Scalars['ID']['input'];
};


export type SubscriptionRequestMovedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionRequestOrderUpdatedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamCollectionAddedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamCollectionMovedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamCollectionRemovedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamCollectionUpdatedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamEnvironmentCreatedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamEnvironmentDeletedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamEnvironmentUpdatedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamInvitationAddedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamInvitationRemovedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamMemberAddedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamMemberRemovedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamMemberUpdatedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamRequestAddedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamRequestDeletedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamRequestUpdatedArgs = {
  teamID: Scalars['ID']['input'];
};

export type Team = {
  __typename?: 'Team';
  /** The number of users with the EDITOR role in the team */
  editorsCount: Scalars['Int']['output'];
  /** ID of the team */
  id: Scalars['ID']['output'];
  /** Returns the list of members of a team */
  members: Array<TeamMember>;
  /** The role of the current user in the team */
  myRole: TeamMemberRole;
  /** Displayed name of the team */
  name: Scalars['String']['output'];
  /** Organization domain */
  orgDomain?: Maybe<Scalars['String']['output']>;
  /** Organization ID where the team belongs to */
  orgID?: Maybe<Scalars['String']['output']>;
  /** Organization name */
  orgName?: Maybe<Scalars['String']['output']>;
  /** The number of users with the OWNER role in the team */
  ownersCount: Scalars['Int']['output'];
  /** Returns all Team Environments for the given Team */
  teamEnvironments: Array<TeamEnvironment>;
  /** Get all the active invites in the team */
  teamInvitations: Array<TeamInvitation>;
  /** Returns the list of members of a team */
  teamMembers: Array<TeamMember>;
  /** The number of users with the VIEWER role in the team */
  viewersCount: Scalars['Int']['output'];
};


export type TeamMembersArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
};

export type TeamCollection = {
  __typename?: 'TeamCollection';
  /** List of children collection */
  children: Array<TeamCollection>;
  /** JSON string representing the collection data */
  data?: Maybe<Scalars['String']['output']>;
  /** ID of the collection */
  id: Scalars['ID']['output'];
  /** The collection whom is the parent of this collection (null if this is root collection) */
  parent?: Maybe<TeamCollection>;
  /** Team the collection belongs to */
  team: Team;
  /** Displayed title of the collection */
  title: Scalars['String']['output'];
};


export type TeamCollectionChildrenArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
};

export type TeamEnvironment = {
  __typename?: 'TeamEnvironment';
  /** ID of the Team Environment */
  id: Scalars['ID']['output'];
  /** Name of the environment */
  name: Scalars['String']['output'];
  /** ID of the team this environment belongs to */
  teamID: Scalars['ID']['output'];
  /** All variables present in the environment */
  variables: Scalars['String']['output'];
};

export type TeamInvitation = {
  __typename?: 'TeamInvitation';
  /** Get the creator of the invite */
  creator: User;
  /** UID of the creator of the invite */
  creatorUid: Scalars['ID']['output'];
  /** ID of the invite */
  id: Scalars['ID']['output'];
  /** Email of the invitee */
  inviteeEmail: Scalars['ID']['output'];
  /** The role that will be given to the invitee */
  inviteeRole: TeamMemberRole;
  /** Get the team associated to the invite */
  team: Team;
  /** ID of the team the invite is to */
  teamID: Scalars['ID']['output'];
};

export type TeamMember = {
  __typename?: 'TeamMember';
  /** Membership ID of the Team Member */
  membershipID: Scalars['ID']['output'];
  /** Role of the given team member in the given team */
  role: TeamMemberRole;
  user: User;
};

export enum TeamMemberRole {
  Editor = 'EDITOR',
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

export type TeamRequest = {
  __typename?: 'TeamRequest';
  /** Collection the request belongs to */
  collection: TeamCollection;
  /** ID of the collection the request belongs to. */
  collectionID: Scalars['ID']['output'];
  /** ID of the request */
  id: Scalars['ID']['output'];
  /** JSON string representing the request data */
  request: Scalars['String']['output'];
  /** Team the request belongs to */
  team: Team;
  /** ID of the team the request belongs to. */
  teamID: Scalars['ID']['output'];
  /** Displayed title of the request */
  title: Scalars['String']['output'];
};

export type UpdateTeamRequestInput = {
  /** JSON string representing the request data */
  request?: InputMaybe<Scalars['String']['input']>;
  /** Displayed title of the request */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  /** Displayed name of the user (if given) */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Email of the user (if given) */
  email?: Maybe<Scalars['String']['output']>;
  /** URL to the profile photo of the user (if given) */
  photoURL?: Maybe<Scalars['String']['output']>;
  /** Firebase UID of the user */
  uid: Scalars['ID']['output'];
};

export type AcceptOrganizationInvitationMutationVariables = Exact<{
  orgInviteID: Scalars['ID']['input'];
}>;


export type AcceptOrganizationInvitationMutation = { __typename?: 'Mutation', acceptOrganizationInvitation: { __typename?: 'OrganizationMember', userUID: string } };

export type AddUserToTeamByAdminMutationVariables = Exact<{
  userEmail: Scalars['ID']['input'];
  orgID: Scalars['ID']['input'];
  teamID: Scalars['ID']['input'];
  userRole: TeamMemberRole;
}>;


export type AddUserToTeamByAdminMutation = { __typename?: 'Mutation', addUserToTeamByAdmin: { __typename?: 'TeamMember', membershipID: string, role: TeamMemberRole, user: { __typename?: 'User', uid: string } } };

export type CreateTeamByAdminMutationVariables = Exact<{
  orgID: Scalars['ID']['input'];
  userUid: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type CreateTeamByAdminMutation = { __typename?: 'Mutation', createTeamByAdmin: { __typename?: 'Team', id: string } };

export type DeactivateOrganizationMemberMutationVariables = Exact<{
  orgMemberID: Scalars['ID']['input'];
  orgID: Scalars['ID']['input'];
}>;


export type DeactivateOrganizationMemberMutation = { __typename?: 'Mutation', deactivateOrganizationMember: boolean };

export type DeleteTeamByAdminMutationVariables = Exact<{
  orgID: Scalars['ID']['input'];
  teamID: Scalars['ID']['input'];
}>;


export type DeleteTeamByAdminMutation = { __typename?: 'Mutation', deleteTeamByAdmin: boolean };

export type DemoteOrganizationMembersAdminMutationVariables = Exact<{
  userUIDs: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  orgID: Scalars['ID']['input'];
}>;


export type DemoteOrganizationMembersAdminMutation = { __typename?: 'Mutation', demoteOrganizationMembersAsAdmin: boolean };

export type InviteNewUserMutationVariables = Exact<{
  inviteeEmail: Scalars['String']['input'];
  orgID: Scalars['ID']['input'];
}>;


export type InviteNewUserMutation = { __typename?: 'Mutation', inviteNewUser: { __typename?: 'InvitedUser', inviteID: string } };

export type MakeOrganizationMembersAdminMutationVariables = Exact<{
  userUIDs: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  orgID: Scalars['ID']['input'];
}>;


export type MakeOrganizationMembersAdminMutation = { __typename?: 'Mutation', makeOrganizationMembersAdmin: boolean };

export type RemoveMemberFromTeamByAdminMutationVariables = Exact<{
  orgID: Scalars['ID']['input'];
  teamID: Scalars['ID']['input'];
  userUid: Scalars['ID']['input'];
}>;


export type RemoveMemberFromTeamByAdminMutation = { __typename?: 'Mutation', removeMemberFromTeamByAdmin: boolean };

export type RemoveOrganizationMemberMutationVariables = Exact<{
  orgMemberID: Scalars['ID']['input'];
  orgID: Scalars['ID']['input'];
}>;


export type RemoveOrganizationMemberMutation = { __typename?: 'Mutation', removeOrganizationMember: { __typename?: 'OrganizationMember', userUID: string } };

export type RenameTeamByAdminMutationVariables = Exact<{
  orgID: Scalars['ID']['input'];
  teamID: Scalars['ID']['input'];
  newTeamName: Scalars['String']['input'];
}>;


export type RenameTeamByAdminMutation = { __typename?: 'Mutation', renameTeamByAdmin: { __typename?: 'Team', id: string, name: string } };

export type RevokeOrganizationMemberInvitationsByAdminMutationVariables = Exact<{
  inviteeEmails: Array<Scalars['String']['input']> | Scalars['String']['input'];
  orgID: Scalars['ID']['input'];
}>;


export type RevokeOrganizationMemberInvitationsByAdminMutation = { __typename?: 'Mutation', revokeOrganizationMemberInvitationsByAdmin: boolean };

export type RevokeOrganizationTeamInviteByAdminMutationVariables = Exact<{
  inviteID: Scalars['ID']['input'];
  orgID: Scalars['ID']['input'];
}>;


export type RevokeOrganizationTeamInviteByAdminMutation = { __typename?: 'Mutation', revokeOrganizationTeamInviteByAdmin: boolean };

export type UpdateOrganizationTeamMemberRoleByAdminMutationVariables = Exact<{
  orgID: Scalars['ID']['input'];
  teamID: Scalars['ID']['input'];
  userUid: Scalars['ID']['input'];
  newRole: TeamMemberRole;
}>;


export type UpdateOrganizationTeamMemberRoleByAdminMutation = { __typename?: 'Mutation', updateOrganizationTeamMemberRoleByAdmin: { __typename?: 'TeamMember', membershipID: string, role: TeamMemberRole } };

export type GetInvitedOrganizationMembersQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type GetInvitedOrganizationMembersQuery = { __typename?: 'Query', invitedOrganizationMembers: Array<{ __typename?: 'InvitedUser', inviteID: string, adminEmail: string, inviteeEmail: string, invitedOn: any }> };

export type GetOrganizationInviteDetailsQueryVariables = Exact<{
  inviteID: Scalars['ID']['input'];
}>;


export type GetOrganizationInviteDetailsQuery = { __typename?: 'Query', getOrgInviteDetails: { __typename?: 'InvitedUser', adminEmail: string, adminName?: string | null, orgName?: string | null } };

export type GetOrganizationMemberDetailsQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
  orgMemberID: Scalars['ID']['input'];
}>;


export type GetOrganizationMemberDetailsQuery = { __typename?: 'Query', organizationMember: { __typename?: 'OrganizationMember', userUID: string, userName?: string | null, userEmail?: string | null, orgID: string, invitedOn: any, isAdmin: boolean, inviteeUserUID?: string | null, lastActiveOn: any, createdOn: any, photoURL?: string | null } };

export type GetOrganizationMembersQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type GetOrganizationMembersQuery = { __typename?: 'Query', organizationMembers: Array<{ __typename?: 'OrganizationMember', userUID: string, userName?: string | null, userEmail?: string | null, orgID: string, invitedOn: any, isAdmin: boolean, inviteeUserUID?: string | null, lastActiveOn: any, createdOn: any }> };

export type GetOrganizationMembersCountQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type GetOrganizationMembersCountQuery = { __typename?: 'Query', organizationMembersCount: number };

export type GetOrganizationTeamCollectionsCountQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type GetOrganizationTeamCollectionsCountQuery = { __typename?: 'Query', organizationTeamCollectionsCount: number };

export type GetOrganizationTeamInfoQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
  teamID: Scalars['ID']['input'];
}>;


export type GetOrganizationTeamInfoQuery = { __typename?: 'Query', organizationTeamInfo: { __typename?: 'Team', id: string, name: string, teamMembers: Array<{ __typename?: 'TeamMember', membershipID: string, role: TeamMemberRole, user: { __typename?: 'User', uid: string, email?: string | null } }>, teamInvitations: Array<{ __typename?: 'TeamInvitation', id: string, inviteeEmail: string, inviteeRole: TeamMemberRole }> } };

export type GetOrganizationTeamRequestsCountQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type GetOrganizationTeamRequestsCountQuery = { __typename?: 'Query', organizationTeamRequestsCount: number };

export type GetOrganizationTeamsQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type GetOrganizationTeamsQuery = { __typename?: 'Query', organizationTeams: Array<{ __typename?: 'Team', id: string, name: string, members: Array<{ __typename?: 'TeamMember', user: { __typename?: 'User', uid: string, email?: string | null } }> }> };

export type GetOrganizationTeamsCountQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type GetOrganizationTeamsCountQuery = { __typename?: 'Query', organizationTeamsCount: number };

export type UpdateOrganizationBillingCycleMutationVariables = Exact<{
  orgID: Scalars['ID']['input'];
  orgBillingCycle: OrganizationBillingCycle;
}>;


export type UpdateOrganizationBillingCycleMutation = { __typename?: 'Mutation', updateOrganizationBillingCycle: boolean };

export type UpdateOrganizationSeatsMutationVariables = Exact<{
  orgID: Scalars['ID']['input'];
  seats: Scalars['Float']['input'];
}>;


export type UpdateOrganizationSeatsMutation = { __typename?: 'Mutation', updateOrganizationSeats: boolean };

export type OrganizationMemberAddedSubscriptionVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type OrganizationMemberAddedSubscription = { __typename?: 'Subscription', organizationMemberAdded: { __typename?: 'OrganizationMember', userUID: string, userName?: string | null, userEmail?: string | null, orgID: string, invitedOn: any, isAdmin: boolean, inviteeUserUID?: string | null, lastActiveOn: any, createdOn: any } };

export type AcceptTeamInvitationMutationVariables = Exact<{
  inviteID: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AcceptTeamInvitationMutation = { __typename?: 'Mutation', acceptTeamInvitation: { __typename?: 'TeamMember', membershipID: string, role: TeamMemberRole, user: { __typename?: 'User', uid: string, displayName?: string | null, photoURL?: string | null, email?: string | null } } };

export type CreateShortcodeMutationVariables = Exact<{
  request: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['String']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateShortcodeMutation = { __typename?: 'Mutation', createShortcode: { __typename?: 'Shortcode', id: string, request: string, createdOn: any, properties?: string | null } };

export type CreateTeamMutationVariables = Exact<{
  name: Scalars['String']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'Team', id: string, name: string, myRole: TeamMemberRole, ownersCount: number, editorsCount: number, viewersCount: number, members: Array<{ __typename?: 'TeamMember', membershipID: string, role: TeamMemberRole, user: { __typename?: 'User', uid: string, displayName?: string | null, email?: string | null, photoURL?: string | null } }> } };

export type CreateTeamInvitationMutationVariables = Exact<{
  inviteeEmail: Scalars['String']['input'];
  inviteeRole: TeamMemberRole;
  teamID: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateTeamInvitationMutation = { __typename?: 'Mutation', createTeamInvitation: { __typename?: 'TeamInvitation', id: string, teamID: string, creatorUid: string, inviteeEmail: string, inviteeRole: TeamMemberRole } };

export type InitiateOrganizationPurchaseMutationVariables = Exact<{
  organizationName: Scalars['String']['input'];
  organizationDomain: Scalars['String']['input'];
  organizationSeats: Scalars['Float']['input'];
  organizationMetadata?: InputMaybe<Scalars['String']['input']>;
  organizationBillingCycle: OrganizationBillingCycle;
}>;


export type InitiateOrganizationPurchaseMutation = { __typename?: 'Mutation', initiateOrganizationPurchase: string };

export type GetInviteDetailsQueryVariables = Exact<{
  inviteID: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetInviteDetailsQuery = { __typename?: 'Query', teamInvitation: { __typename?: 'TeamInvitation', id: string, inviteeEmail: string, inviteeRole: TeamMemberRole, team: { __typename?: 'Team', id: string, name: string }, creator: { __typename?: 'User', uid: string, displayName?: string | null, email?: string | null } } };

export type GetUserShortcodesQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['ID']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetUserShortcodesQuery = { __typename?: 'Query', myShortcodes: Array<{ __typename?: 'Shortcode', id: string, request: string, createdOn: any, properties?: string | null }> };

export type GetMyTeamsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['ID']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetMyTeamsQuery = { __typename?: 'Query', myTeams: Array<{ __typename?: 'Team', id: string, name: string, myRole: TeamMemberRole, ownersCount: number, orgDomain?: string | null, orgName?: string | null, teamMembers: Array<{ __typename?: 'TeamMember', membershipID: string, role: TeamMemberRole, user: { __typename?: 'User', photoURL?: string | null, displayName?: string | null, email?: string | null, uid: string } }> }> };

export type GetOrganizationInfoByDomainQueryVariables = Exact<{
  orgDomain: Scalars['ID']['input'];
}>;


export type GetOrganizationInfoByDomainQuery = { __typename?: 'Query', organizationByDomain: string };

export type GetOrganizationInfoByIdQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type GetOrganizationInfoByIdQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', orgID: string, orgName: string, orgDomain: string, createdOn: any, seats: number, orgMetadata?: string | null, billingEmail?: string | null, billingCycle?: OrganizationBillingCycle | null, nextBillingDate?: number | null, orgStatus: OrganizationStatus, billingAddress?: { __typename?: 'OrganizationBillingAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, country?: string | null, postal_code?: string | null } | null } };


export const AcceptOrganizationInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"acceptOrganizationInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgInviteID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptOrganizationInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgInviteID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgInviteID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userUID"}}]}}]}}]} as unknown as DocumentNode<AcceptOrganizationInvitationMutation, AcceptOrganizationInvitationMutationVariables>;
export const AddUserToTeamByAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddUserToTeamByAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userRole"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMemberRole"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addUserToTeamByAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}}},{"kind":"Argument","name":{"kind":"Name","value":"userRole"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userRole"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipID"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}}]}}]}}]}}]} as unknown as DocumentNode<AddUserToTeamByAdminMutation, AddUserToTeamByAdminMutationVariables>;
export const CreateTeamByAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTeamByAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTeamByAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"userUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userUid"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateTeamByAdminMutation, CreateTeamByAdminMutationVariables>;
export const DeactivateOrganizationMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeactivateOrganizationMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgMemberID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deactivateOrganizationMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgMemberID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgMemberID"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}]}]}}]} as unknown as DocumentNode<DeactivateOrganizationMemberMutation, DeactivateOrganizationMemberMutationVariables>;
export const DeleteTeamByAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTeamByAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTeamByAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}}}]}]}}]} as unknown as DocumentNode<DeleteTeamByAdminMutation, DeleteTeamByAdminMutationVariables>;
export const DemoteOrganizationMembersAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DemoteOrganizationMembersAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userUIDs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demoteOrganizationMembersAsAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userUIDs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userUIDs"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}]}]}}]} as unknown as DocumentNode<DemoteOrganizationMembersAdminMutation, DemoteOrganizationMembersAdminMutationVariables>;
export const InviteNewUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InviteNewUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteeEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inviteNewUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inviteeEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteeEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inviteID"}}]}}]}}]} as unknown as DocumentNode<InviteNewUserMutation, InviteNewUserMutationVariables>;
export const MakeOrganizationMembersAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MakeOrganizationMembersAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userUIDs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"makeOrganizationMembersAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userUIDs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userUIDs"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}]}]}}]} as unknown as DocumentNode<MakeOrganizationMembersAdminMutation, MakeOrganizationMembersAdminMutationVariables>;
export const RemoveMemberFromTeamByAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveMemberFromTeamByAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMemberFromTeamByAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}}},{"kind":"Argument","name":{"kind":"Name","value":"userUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userUid"}}}]}]}}]} as unknown as DocumentNode<RemoveMemberFromTeamByAdminMutation, RemoveMemberFromTeamByAdminMutationVariables>;
export const RemoveOrganizationMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveOrganizationMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgMemberID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeOrganizationMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgMemberID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgMemberID"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userUID"}}]}}]}}]} as unknown as DocumentNode<RemoveOrganizationMemberMutation, RemoveOrganizationMemberMutationVariables>;
export const RenameTeamByAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RenameTeamByAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newTeamName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renameTeamByAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}}},{"kind":"Argument","name":{"kind":"Name","value":"newTeamName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newTeamName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<RenameTeamByAdminMutation, RenameTeamByAdminMutationVariables>;
export const RevokeOrganizationMemberInvitationsByAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"revokeOrganizationMemberInvitationsByAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteeEmails"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revokeOrganizationMemberInvitationsByAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inviteeEmails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteeEmails"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}]}]}}]} as unknown as DocumentNode<RevokeOrganizationMemberInvitationsByAdminMutation, RevokeOrganizationMemberInvitationsByAdminMutationVariables>;
export const RevokeOrganizationTeamInviteByAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RevokeOrganizationTeamInviteByAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revokeOrganizationTeamInviteByAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inviteID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteID"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}]}]}}]} as unknown as DocumentNode<RevokeOrganizationTeamInviteByAdminMutation, RevokeOrganizationTeamInviteByAdminMutationVariables>;
export const UpdateOrganizationTeamMemberRoleByAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrganizationTeamMemberRoleByAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newRole"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMemberRole"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganizationTeamMemberRoleByAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}}},{"kind":"Argument","name":{"kind":"Name","value":"userUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userUid"}}},{"kind":"Argument","name":{"kind":"Name","value":"newRole"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newRole"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipID"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]} as unknown as DocumentNode<UpdateOrganizationTeamMemberRoleByAdminMutation, UpdateOrganizationTeamMemberRoleByAdminMutationVariables>;
export const GetInvitedOrganizationMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInvitedOrganizationMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invitedOrganizationMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inviteID"}},{"kind":"Field","name":{"kind":"Name","value":"adminEmail"}},{"kind":"Field","name":{"kind":"Name","value":"inviteeEmail"}},{"kind":"Field","name":{"kind":"Name","value":"invitedOn"}}]}}]}}]} as unknown as DocumentNode<GetInvitedOrganizationMembersQuery, GetInvitedOrganizationMembersQueryVariables>;
export const GetOrganizationInviteDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationInviteDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrgInviteDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inviteID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminEmail"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"orgName"}}]}}]}}]} as unknown as DocumentNode<GetOrganizationInviteDetailsQuery, GetOrganizationInviteDetailsQueryVariables>;
export const GetOrganizationMemberDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationMemberDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgMemberID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgMemberID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgMemberID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userUID"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"orgID"}},{"kind":"Field","name":{"kind":"Name","value":"invitedOn"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"inviteeUserUID"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveOn"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"photoURL"}}]}}]}}]} as unknown as DocumentNode<GetOrganizationMemberDetailsQuery, GetOrganizationMemberDetailsQueryVariables>;
export const GetOrganizationMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userUID"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"orgID"}},{"kind":"Field","name":{"kind":"Name","value":"invitedOn"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"inviteeUserUID"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveOn"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}}]}}]}}]} as unknown as DocumentNode<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>;
export const GetOrganizationMembersCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationMembersCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationMembersCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}]}]}}]} as unknown as DocumentNode<GetOrganizationMembersCountQuery, GetOrganizationMembersCountQueryVariables>;
export const GetOrganizationTeamCollectionsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationTeamCollectionsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationTeamCollectionsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}]}]}}]} as unknown as DocumentNode<GetOrganizationTeamCollectionsCountQuery, GetOrganizationTeamCollectionsCountQueryVariables>;
export const GetOrganizationTeamInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationTeamInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationTeamInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"teamMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipID"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teamInvitations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inviteeEmail"}},{"kind":"Field","name":{"kind":"Name","value":"inviteeRole"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrganizationTeamInfoQuery, GetOrganizationTeamInfoQueryVariables>;
export const GetOrganizationTeamRequestsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationTeamRequestsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationTeamRequestsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}]}]}}]} as unknown as DocumentNode<GetOrganizationTeamRequestsCountQuery, GetOrganizationTeamRequestsCountQueryVariables>;
export const GetOrganizationTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationTeams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOrganizationTeamsQuery, GetOrganizationTeamsQueryVariables>;
export const GetOrganizationTeamsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationTeamsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationTeamsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}]}]}}]} as unknown as DocumentNode<GetOrganizationTeamsCountQuery, GetOrganizationTeamsCountQueryVariables>;
export const UpdateOrganizationBillingCycleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateOrganizationBillingCycle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgBillingCycle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationBillingCycle"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganizationBillingCycle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgBillingCycle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgBillingCycle"}}}]}]}}]} as unknown as DocumentNode<UpdateOrganizationBillingCycleMutation, UpdateOrganizationBillingCycleMutationVariables>;
export const UpdateOrganizationSeatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateOrganizationSeats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seats"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganizationSeats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"seats"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seats"}}}]}]}}]} as unknown as DocumentNode<UpdateOrganizationSeatsMutation, UpdateOrganizationSeatsMutationVariables>;
export const OrganizationMemberAddedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OrganizationMemberAdded"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationMemberAdded"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userUID"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"orgID"}},{"kind":"Field","name":{"kind":"Name","value":"invitedOn"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"inviteeUserUID"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveOn"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}}]}}]}}]} as unknown as DocumentNode<OrganizationMemberAddedSubscription, OrganizationMemberAddedSubscriptionVariables>;
export const AcceptTeamInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptTeamInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptTeamInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inviteID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteID"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipID"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"photoURL"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<AcceptTeamInvitationMutation, AcceptTeamInvitationMutationVariables>;
export const CreateShortcodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateShortcode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"properties"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createShortcode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"request"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}},{"kind":"Argument","name":{"kind":"Name","value":"properties"},"value":{"kind":"Variable","name":{"kind":"Name","value":"properties"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"request"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"properties"}}]}}]}}]} as unknown as DocumentNode<CreateShortcodeMutation, CreateShortcodeMutationVariables>;
export const CreateTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTeam"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipID"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"photoURL"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"myRole"}},{"kind":"Field","name":{"kind":"Name","value":"ownersCount"}},{"kind":"Field","name":{"kind":"Name","value":"editorsCount"}},{"kind":"Field","name":{"kind":"Name","value":"viewersCount"}}]}}]}}]} as unknown as DocumentNode<CreateTeamMutation, CreateTeamMutationVariables>;
export const CreateTeamInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTeamInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteeEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteeRole"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMemberRole"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTeamInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inviteeRole"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteeRole"}}},{"kind":"Argument","name":{"kind":"Name","value":"inviteeEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteeEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teamID"}},{"kind":"Field","name":{"kind":"Name","value":"creatorUid"}},{"kind":"Field","name":{"kind":"Name","value":"inviteeEmail"}},{"kind":"Field","name":{"kind":"Name","value":"inviteeRole"}}]}}]}}]} as unknown as DocumentNode<CreateTeamInvitationMutation, CreateTeamInvitationMutationVariables>;
export const InitiateOrganizationPurchaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"initiateOrganizationPurchase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationDomain"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSeats"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationMetadata"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationBillingCycle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationBillingCycle"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initiateOrganizationPurchase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationName"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationDomain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationDomain"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationSeats"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSeats"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationMetadata"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationMetadata"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationBillingCycle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationBillingCycle"}}}]}]}}]} as unknown as DocumentNode<InitiateOrganizationPurchaseMutation, InitiateOrganizationPurchaseMutationVariables>;
export const GetInviteDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInviteDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inviteID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteID"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inviteeEmail"}},{"kind":"Field","name":{"kind":"Name","value":"inviteeRole"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<GetInviteDetailsQuery, GetInviteDetailsQueryVariables>;
export const GetUserShortcodesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserShortcodes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myShortcodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"request"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"properties"}}]}}]}}]} as unknown as DocumentNode<GetUserShortcodesQuery, GetUserShortcodesQueryVariables>;
export const GetMyTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myTeams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"myRole"}},{"kind":"Field","name":{"kind":"Name","value":"ownersCount"}},{"kind":"Field","name":{"kind":"Name","value":"orgDomain"}},{"kind":"Field","name":{"kind":"Name","value":"orgName"}},{"kind":"Field","name":{"kind":"Name","value":"teamMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipID"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoURL"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]} as unknown as DocumentNode<GetMyTeamsQuery, GetMyTeamsQueryVariables>;
export const GetOrganizationInfoByDomainDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationInfoByDomain"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgDomain"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationByDomain"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgDomain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgDomain"}}}]}]}}]} as unknown as DocumentNode<GetOrganizationInfoByDomainQuery, GetOrganizationInfoByDomainQueryVariables>;
export const GetOrganizationInfoByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationInfoByID"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgID"}},{"kind":"Field","name":{"kind":"Name","value":"orgName"}},{"kind":"Field","name":{"kind":"Name","value":"orgDomain"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"seats"}},{"kind":"Field","name":{"kind":"Name","value":"orgMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postal_code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingEmail"}},{"kind":"Field","name":{"kind":"Name","value":"billingCycle"}},{"kind":"Field","name":{"kind":"Name","value":"nextBillingDate"}},{"kind":"Field","name":{"kind":"Name","value":"orgStatus"}}]}}]}}]} as unknown as DocumentNode<GetOrganizationInfoByIdQuery, GetOrganizationInfoByIdQueryVariables>;
export type WithTypename<T extends { __typename?: any }> = Partial<T> & { __typename: NonNullable<T['__typename']> };

export type GraphCacheKeysConfig = {
  CollectionReorderData?: (data: WithTypename<CollectionReorderData>) => null | string,
  InvitedUser?: (data: WithTypename<InvitedUser>) => null | string,
  Organization?: (data: WithTypename<Organization>) => null | string,
  OrganizationBillingAddress?: (data: WithTypename<OrganizationBillingAddress>) => null | string,
  OrganizationMember?: (data: WithTypename<OrganizationMember>) => null | string,
  RequestReorderData?: (data: WithTypename<RequestReorderData>) => null | string,
  Shortcode?: (data: WithTypename<Shortcode>) => null | string,
  Team?: (data: WithTypename<Team>) => null | string,
  TeamCollection?: (data: WithTypename<TeamCollection>) => null | string,
  TeamEnvironment?: (data: WithTypename<TeamEnvironment>) => null | string,
  TeamInvitation?: (data: WithTypename<TeamInvitation>) => null | string,
  TeamMember?: (data: WithTypename<TeamMember>) => null | string,
  TeamRequest?: (data: WithTypename<TeamRequest>) => null | string,
  User?: (data: WithTypename<User>) => null | string
}

export type GraphCacheResolvers = {
  Query?: {
    collection?: GraphCacheResolver<WithTypename<Query>, QueryCollectionArgs, WithTypename<TeamCollection> | string>,
    collectionsOfTeam?: GraphCacheResolver<WithTypename<Query>, QueryCollectionsOfTeamArgs, Array<WithTypename<TeamCollection> | string>>,
    exportCollectionsToJSON?: GraphCacheResolver<WithTypename<Query>, QueryExportCollectionsToJsonArgs, Scalars['String'] | string>,
    getOrgInviteDetails?: GraphCacheResolver<WithTypename<Query>, QueryGetOrgInviteDetailsArgs, WithTypename<InvitedUser> | string>,
    invitedOrganizationMembers?: GraphCacheResolver<WithTypename<Query>, QueryInvitedOrganizationMembersArgs, Array<WithTypename<InvitedUser> | string>>,
    me?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, WithTypename<User> | string>,
    myShortcodes?: GraphCacheResolver<WithTypename<Query>, QueryMyShortcodesArgs, Array<WithTypename<Shortcode> | string>>,
    myTeams?: GraphCacheResolver<WithTypename<Query>, QueryMyTeamsArgs, Array<WithTypename<Team> | string>>,
    organization?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationArgs, WithTypename<Organization> | string>,
    organizationByDomain?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationByDomainArgs, Scalars['String'] | string>,
    organizationMember?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationMemberArgs, WithTypename<OrganizationMember> | string>,
    organizationMembers?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationMembersArgs, Array<WithTypename<OrganizationMember> | string>>,
    organizationMembersCount?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationMembersCountArgs, Scalars['Float'] | string>,
    organizationTeamCollectionsCount?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationTeamCollectionsCountArgs, Scalars['Float'] | string>,
    organizationTeamInfo?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationTeamInfoArgs, WithTypename<Team> | string>,
    organizationTeamRequestsCount?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationTeamRequestsCountArgs, Scalars['Float'] | string>,
    organizationTeams?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationTeamsArgs, Array<WithTypename<Team> | string>>,
    organizationTeamsCount?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationTeamsCountArgs, Scalars['Float'] | string>,
    request?: GraphCacheResolver<WithTypename<Query>, QueryRequestArgs, WithTypename<TeamRequest> | string>,
    requestsInCollection?: GraphCacheResolver<WithTypename<Query>, QueryRequestsInCollectionArgs, Array<WithTypename<TeamRequest> | string>>,
    rootCollectionsOfTeam?: GraphCacheResolver<WithTypename<Query>, QueryRootCollectionsOfTeamArgs, Array<WithTypename<TeamCollection> | string>>,
    searchForRequest?: GraphCacheResolver<WithTypename<Query>, QuerySearchForRequestArgs, Array<WithTypename<TeamRequest> | string>>,
    shortcode?: GraphCacheResolver<WithTypename<Query>, QueryShortcodeArgs, WithTypename<Shortcode> | string>,
    team?: GraphCacheResolver<WithTypename<Query>, QueryTeamArgs, WithTypename<Team> | string>,
    teamInvitation?: GraphCacheResolver<WithTypename<Query>, QueryTeamInvitationArgs, WithTypename<TeamInvitation> | string>,
    user?: GraphCacheResolver<WithTypename<Query>, QueryUserArgs, WithTypename<User> | string>
  },
  CollectionReorderData?: {
    collection?: GraphCacheResolver<WithTypename<CollectionReorderData>, Record<string, never>, WithTypename<TeamCollection> | string>,
    nextCollection?: GraphCacheResolver<WithTypename<CollectionReorderData>, Record<string, never>, WithTypename<TeamCollection> | string>
  },
  InvitedUser?: {
    adminEmail?: GraphCacheResolver<WithTypename<InvitedUser>, Record<string, never>, Scalars['String'] | string>,
    adminName?: GraphCacheResolver<WithTypename<InvitedUser>, Record<string, never>, Scalars['String'] | string>,
    adminUid?: GraphCacheResolver<WithTypename<InvitedUser>, Record<string, never>, Scalars['ID'] | string>,
    inviteID?: GraphCacheResolver<WithTypename<InvitedUser>, Record<string, never>, Scalars['ID'] | string>,
    invitedOn?: GraphCacheResolver<WithTypename<InvitedUser>, Record<string, never>, Scalars['DateTime'] | string>,
    inviteeEmail?: GraphCacheResolver<WithTypename<InvitedUser>, Record<string, never>, Scalars['String'] | string>,
    orgID?: GraphCacheResolver<WithTypename<InvitedUser>, Record<string, never>, Scalars['ID'] | string>,
    orgName?: GraphCacheResolver<WithTypename<InvitedUser>, Record<string, never>, Scalars['String'] | string>
  },
  Organization?: {
    billingAddress?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, WithTypename<OrganizationBillingAddress> | string>,
    billingCycle?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, OrganizationBillingCycle | string>,
    billingEmail?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, Scalars['String'] | string>,
    checkoutUrl?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, Scalars['String'] | string>,
    createdOn?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, Scalars['DateTime'] | string>,
    nextBillingDate?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, Scalars['Float'] | string>,
    orgDomain?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, Scalars['String'] | string>,
    orgID?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, Scalars['ID'] | string>,
    orgMetadata?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, Scalars['String'] | string>,
    orgName?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, Scalars['String'] | string>,
    orgStatus?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, OrganizationStatus | string>,
    seats?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, Scalars['Float'] | string>
  },
  OrganizationBillingAddress?: {
    city?: GraphCacheResolver<WithTypename<OrganizationBillingAddress>, Record<string, never>, Scalars['String'] | string>,
    country?: GraphCacheResolver<WithTypename<OrganizationBillingAddress>, Record<string, never>, Scalars['String'] | string>,
    line1?: GraphCacheResolver<WithTypename<OrganizationBillingAddress>, Record<string, never>, Scalars['String'] | string>,
    line2?: GraphCacheResolver<WithTypename<OrganizationBillingAddress>, Record<string, never>, Scalars['String'] | string>,
    postal_code?: GraphCacheResolver<WithTypename<OrganizationBillingAddress>, Record<string, never>, Scalars['String'] | string>,
    state?: GraphCacheResolver<WithTypename<OrganizationBillingAddress>, Record<string, never>, Scalars['String'] | string>
  },
  OrganizationMember?: {
    createdOn?: GraphCacheResolver<WithTypename<OrganizationMember>, Record<string, never>, Scalars['DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<OrganizationMember>, Record<string, never>, Scalars['ID'] | string>,
    invitedOn?: GraphCacheResolver<WithTypename<OrganizationMember>, Record<string, never>, Scalars['DateTime'] | string>,
    inviteeUserUID?: GraphCacheResolver<WithTypename<OrganizationMember>, Record<string, never>, Scalars['ID'] | string>,
    isAdmin?: GraphCacheResolver<WithTypename<OrganizationMember>, Record<string, never>, Scalars['Boolean'] | string>,
    lastActiveOn?: GraphCacheResolver<WithTypename<OrganizationMember>, Record<string, never>, Scalars['DateTime'] | string>,
    membershipStatus?: GraphCacheResolver<WithTypename<OrganizationMember>, Record<string, never>, OrganizationMembershipStatus | string>,
    orgID?: GraphCacheResolver<WithTypename<OrganizationMember>, Record<string, never>, Scalars['String'] | string>,
    photoURL?: GraphCacheResolver<WithTypename<OrganizationMember>, Record<string, never>, Scalars['String'] | string>,
    userEmail?: GraphCacheResolver<WithTypename<OrganizationMember>, Record<string, never>, Scalars['String'] | string>,
    userName?: GraphCacheResolver<WithTypename<OrganizationMember>, Record<string, never>, Scalars['String'] | string>,
    userUID?: GraphCacheResolver<WithTypename<OrganizationMember>, Record<string, never>, Scalars['String'] | string>
  },
  RequestReorderData?: {
    nextRequest?: GraphCacheResolver<WithTypename<RequestReorderData>, Record<string, never>, WithTypename<TeamRequest> | string>,
    request?: GraphCacheResolver<WithTypename<RequestReorderData>, Record<string, never>, WithTypename<TeamRequest> | string>
  },
  Shortcode?: {
    createdOn?: GraphCacheResolver<WithTypename<Shortcode>, Record<string, never>, Scalars['DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<Shortcode>, Record<string, never>, Scalars['ID'] | string>,
    orgID?: GraphCacheResolver<WithTypename<Shortcode>, Record<string, never>, Scalars['String'] | string>,
    properties?: GraphCacheResolver<WithTypename<Shortcode>, Record<string, never>, Scalars['String'] | string>,
    request?: GraphCacheResolver<WithTypename<Shortcode>, Record<string, never>, Scalars['String'] | string>
  },
  Team?: {
    editorsCount?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Scalars['Int'] | string>,
    id?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Scalars['ID'] | string>,
    members?: GraphCacheResolver<WithTypename<Team>, TeamMembersArgs, Array<WithTypename<TeamMember> | string>>,
    myRole?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, TeamMemberRole | string>,
    name?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Scalars['String'] | string>,
    orgDomain?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Scalars['String'] | string>,
    orgID?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Scalars['String'] | string>,
    orgName?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Scalars['String'] | string>,
    ownersCount?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Scalars['Int'] | string>,
    teamEnvironments?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Array<WithTypename<TeamEnvironment> | string>>,
    teamInvitations?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Array<WithTypename<TeamInvitation> | string>>,
    teamMembers?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Array<WithTypename<TeamMember> | string>>,
    viewersCount?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Scalars['Int'] | string>
  },
  TeamCollection?: {
    children?: GraphCacheResolver<WithTypename<TeamCollection>, TeamCollectionChildrenArgs, Array<WithTypename<TeamCollection> | string>>,
    data?: GraphCacheResolver<WithTypename<TeamCollection>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<TeamCollection>, Record<string, never>, Scalars['ID'] | string>,
    parent?: GraphCacheResolver<WithTypename<TeamCollection>, Record<string, never>, WithTypename<TeamCollection> | string>,
    team?: GraphCacheResolver<WithTypename<TeamCollection>, Record<string, never>, WithTypename<Team> | string>,
    title?: GraphCacheResolver<WithTypename<TeamCollection>, Record<string, never>, Scalars['String'] | string>
  },
  TeamEnvironment?: {
    id?: GraphCacheResolver<WithTypename<TeamEnvironment>, Record<string, never>, Scalars['ID'] | string>,
    name?: GraphCacheResolver<WithTypename<TeamEnvironment>, Record<string, never>, Scalars['String'] | string>,
    teamID?: GraphCacheResolver<WithTypename<TeamEnvironment>, Record<string, never>, Scalars['ID'] | string>,
    variables?: GraphCacheResolver<WithTypename<TeamEnvironment>, Record<string, never>, Scalars['String'] | string>
  },
  TeamInvitation?: {
    creator?: GraphCacheResolver<WithTypename<TeamInvitation>, Record<string, never>, WithTypename<User> | string>,
    creatorUid?: GraphCacheResolver<WithTypename<TeamInvitation>, Record<string, never>, Scalars['ID'] | string>,
    id?: GraphCacheResolver<WithTypename<TeamInvitation>, Record<string, never>, Scalars['ID'] | string>,
    inviteeEmail?: GraphCacheResolver<WithTypename<TeamInvitation>, Record<string, never>, Scalars['ID'] | string>,
    inviteeRole?: GraphCacheResolver<WithTypename<TeamInvitation>, Record<string, never>, TeamMemberRole | string>,
    team?: GraphCacheResolver<WithTypename<TeamInvitation>, Record<string, never>, WithTypename<Team> | string>,
    teamID?: GraphCacheResolver<WithTypename<TeamInvitation>, Record<string, never>, Scalars['ID'] | string>
  },
  TeamMember?: {
    membershipID?: GraphCacheResolver<WithTypename<TeamMember>, Record<string, never>, Scalars['ID'] | string>,
    role?: GraphCacheResolver<WithTypename<TeamMember>, Record<string, never>, TeamMemberRole | string>,
    user?: GraphCacheResolver<WithTypename<TeamMember>, Record<string, never>, WithTypename<User> | string>
  },
  TeamRequest?: {
    collection?: GraphCacheResolver<WithTypename<TeamRequest>, Record<string, never>, WithTypename<TeamCollection> | string>,
    collectionID?: GraphCacheResolver<WithTypename<TeamRequest>, Record<string, never>, Scalars['ID'] | string>,
    id?: GraphCacheResolver<WithTypename<TeamRequest>, Record<string, never>, Scalars['ID'] | string>,
    request?: GraphCacheResolver<WithTypename<TeamRequest>, Record<string, never>, Scalars['String'] | string>,
    team?: GraphCacheResolver<WithTypename<TeamRequest>, Record<string, never>, WithTypename<Team> | string>,
    teamID?: GraphCacheResolver<WithTypename<TeamRequest>, Record<string, never>, Scalars['ID'] | string>,
    title?: GraphCacheResolver<WithTypename<TeamRequest>, Record<string, never>, Scalars['String'] | string>
  },
  User?: {
    displayName?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    email?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    photoURL?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    uid?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['ID'] | string>
  }
};

export type GraphCacheOptimisticUpdaters = {
  acceptOrganizationInvitation?: GraphCacheOptimisticMutationResolver<MutationAcceptOrganizationInvitationArgs, WithTypename<OrganizationMember>>,
  acceptTeamInvitation?: GraphCacheOptimisticMutationResolver<MutationAcceptTeamInvitationArgs, WithTypename<TeamMember>>,
  addOrganizationMember?: GraphCacheOptimisticMutationResolver<MutationAddOrganizationMemberArgs, WithTypename<OrganizationMember>>,
  addTeamMemberByEmail?: GraphCacheOptimisticMutationResolver<MutationAddTeamMemberByEmailArgs, WithTypename<TeamMember>>,
  addUserToTeamByAdmin?: GraphCacheOptimisticMutationResolver<MutationAddUserToTeamByAdminArgs, WithTypename<TeamMember>>,
  cancelOrganizationSubscription?: GraphCacheOptimisticMutationResolver<MutationCancelOrganizationSubscriptionArgs, Scalars['Boolean']>,
  createChildCollection?: GraphCacheOptimisticMutationResolver<MutationCreateChildCollectionArgs, WithTypename<TeamCollection>>,
  createDuplicateEnvironment?: GraphCacheOptimisticMutationResolver<MutationCreateDuplicateEnvironmentArgs, WithTypename<TeamEnvironment>>,
  createRequestInCollection?: GraphCacheOptimisticMutationResolver<MutationCreateRequestInCollectionArgs, WithTypename<TeamRequest>>,
  createRootCollection?: GraphCacheOptimisticMutationResolver<MutationCreateRootCollectionArgs, WithTypename<TeamCollection>>,
  createShortcode?: GraphCacheOptimisticMutationResolver<MutationCreateShortcodeArgs, WithTypename<Shortcode>>,
  createTeam?: GraphCacheOptimisticMutationResolver<MutationCreateTeamArgs, WithTypename<Team>>,
  createTeamByAdmin?: GraphCacheOptimisticMutationResolver<MutationCreateTeamByAdminArgs, WithTypename<Team>>,
  createTeamEnvironment?: GraphCacheOptimisticMutationResolver<MutationCreateTeamEnvironmentArgs, WithTypename<TeamEnvironment>>,
  createTeamInvitation?: GraphCacheOptimisticMutationResolver<MutationCreateTeamInvitationArgs, WithTypename<TeamInvitation>>,
  deactivateOrganizationMember?: GraphCacheOptimisticMutationResolver<MutationDeactivateOrganizationMemberArgs, Scalars['Boolean']>,
  deleteAllVariablesFromTeamEnvironment?: GraphCacheOptimisticMutationResolver<MutationDeleteAllVariablesFromTeamEnvironmentArgs, WithTypename<TeamEnvironment>>,
  deleteCollection?: GraphCacheOptimisticMutationResolver<MutationDeleteCollectionArgs, Scalars['Boolean']>,
  deleteRequest?: GraphCacheOptimisticMutationResolver<MutationDeleteRequestArgs, Scalars['Boolean']>,
  deleteTeam?: GraphCacheOptimisticMutationResolver<MutationDeleteTeamArgs, Scalars['Boolean']>,
  deleteTeamByAdmin?: GraphCacheOptimisticMutationResolver<MutationDeleteTeamByAdminArgs, Scalars['Boolean']>,
  deleteTeamEnvironment?: GraphCacheOptimisticMutationResolver<MutationDeleteTeamEnvironmentArgs, Scalars['Boolean']>,
  deleteUser?: GraphCacheOptimisticMutationResolver<Record<string, never>, Scalars['Boolean']>,
  demoteOrganizationMembersAsAdmin?: GraphCacheOptimisticMutationResolver<MutationDemoteOrganizationMembersAsAdminArgs, Scalars['Boolean']>,
  duplicateTeamCollection?: GraphCacheOptimisticMutationResolver<MutationDuplicateTeamCollectionArgs, Scalars['Boolean']>,
  importCollectionFromUserFirestore?: GraphCacheOptimisticMutationResolver<MutationImportCollectionFromUserFirestoreArgs, WithTypename<TeamCollection>>,
  importCollectionsFromJSON?: GraphCacheOptimisticMutationResolver<MutationImportCollectionsFromJsonArgs, Scalars['Boolean']>,
  initiateOrganizationPurchase?: GraphCacheOptimisticMutationResolver<MutationInitiateOrganizationPurchaseArgs, Scalars['String']>,
  inviteNewUser?: GraphCacheOptimisticMutationResolver<MutationInviteNewUserArgs, WithTypename<InvitedUser>>,
  leaveTeam?: GraphCacheOptimisticMutationResolver<MutationLeaveTeamArgs, Scalars['Boolean']>,
  makeOrganizationMemberAnAdmin?: GraphCacheOptimisticMutationResolver<MutationMakeOrganizationMemberAnAdminArgs, WithTypename<OrganizationMember>>,
  makeOrganizationMembersAdmin?: GraphCacheOptimisticMutationResolver<MutationMakeOrganizationMembersAdminArgs, Scalars['Boolean']>,
  moveCollection?: GraphCacheOptimisticMutationResolver<MutationMoveCollectionArgs, WithTypename<TeamCollection>>,
  moveRequest?: GraphCacheOptimisticMutationResolver<MutationMoveRequestArgs, WithTypename<TeamRequest>>,
  removeMemberFromTeamByAdmin?: GraphCacheOptimisticMutationResolver<MutationRemoveMemberFromTeamByAdminArgs, Scalars['Boolean']>,
  removeOrganizationMember?: GraphCacheOptimisticMutationResolver<MutationRemoveOrganizationMemberArgs, WithTypename<OrganizationMember>>,
  removeTeamMember?: GraphCacheOptimisticMutationResolver<MutationRemoveTeamMemberArgs, Scalars['Boolean']>,
  renameCollection?: GraphCacheOptimisticMutationResolver<MutationRenameCollectionArgs, WithTypename<TeamCollection>>,
  renameTeam?: GraphCacheOptimisticMutationResolver<MutationRenameTeamArgs, WithTypename<Team>>,
  renameTeamByAdmin?: GraphCacheOptimisticMutationResolver<MutationRenameTeamByAdminArgs, WithTypename<Team>>,
  replaceCollectionsWithJSON?: GraphCacheOptimisticMutationResolver<MutationReplaceCollectionsWithJsonArgs, Scalars['Boolean']>,
  revokeOrganizationMemberAdminAccess?: GraphCacheOptimisticMutationResolver<MutationRevokeOrganizationMemberAdminAccessArgs, WithTypename<OrganizationMember>>,
  revokeOrganizationMemberInvitationsByAdmin?: GraphCacheOptimisticMutationResolver<MutationRevokeOrganizationMemberInvitationsByAdminArgs, Scalars['Boolean']>,
  revokeOrganizationTeamInviteByAdmin?: GraphCacheOptimisticMutationResolver<MutationRevokeOrganizationTeamInviteByAdminArgs, Scalars['Boolean']>,
  revokeShortcode?: GraphCacheOptimisticMutationResolver<MutationRevokeShortcodeArgs, Scalars['Boolean']>,
  revokeTeamInvitation?: GraphCacheOptimisticMutationResolver<MutationRevokeTeamInvitationArgs, Scalars['Boolean']>,
  updateCollectionOrder?: GraphCacheOptimisticMutationResolver<MutationUpdateCollectionOrderArgs, Scalars['Boolean']>,
  updateEmbedProperties?: GraphCacheOptimisticMutationResolver<MutationUpdateEmbedPropertiesArgs, WithTypename<Shortcode>>,
  updateLookUpRequestOrder?: GraphCacheOptimisticMutationResolver<MutationUpdateLookUpRequestOrderArgs, Scalars['Boolean']>,
  updateOrganizationBillingCycle?: GraphCacheOptimisticMutationResolver<MutationUpdateOrganizationBillingCycleArgs, Scalars['Boolean']>,
  updateOrganizationSeats?: GraphCacheOptimisticMutationResolver<MutationUpdateOrganizationSeatsArgs, Scalars['Boolean']>,
  updateOrganizationTeamMemberRoleByAdmin?: GraphCacheOptimisticMutationResolver<MutationUpdateOrganizationTeamMemberRoleByAdminArgs, WithTypename<TeamMember>>,
  updateRequest?: GraphCacheOptimisticMutationResolver<MutationUpdateRequestArgs, WithTypename<TeamRequest>>,
  updateTeamCollection?: GraphCacheOptimisticMutationResolver<MutationUpdateTeamCollectionArgs, WithTypename<TeamCollection>>,
  updateTeamEnvironment?: GraphCacheOptimisticMutationResolver<MutationUpdateTeamEnvironmentArgs, WithTypename<TeamEnvironment>>,
  updateTeamMemberRole?: GraphCacheOptimisticMutationResolver<MutationUpdateTeamMemberRoleArgs, WithTypename<TeamMember>>
};

export type GraphCacheUpdaters = {
  Query?: {
    collection?: GraphCacheUpdateResolver<{ collection: Maybe<WithTypename<TeamCollection>> }, QueryCollectionArgs>,
    collectionsOfTeam?: GraphCacheUpdateResolver<{ collectionsOfTeam: Array<WithTypename<TeamCollection>> }, QueryCollectionsOfTeamArgs>,
    exportCollectionsToJSON?: GraphCacheUpdateResolver<{ exportCollectionsToJSON: Scalars['String'] }, QueryExportCollectionsToJsonArgs>,
    getOrgInviteDetails?: GraphCacheUpdateResolver<{ getOrgInviteDetails: WithTypename<InvitedUser> }, QueryGetOrgInviteDetailsArgs>,
    invitedOrganizationMembers?: GraphCacheUpdateResolver<{ invitedOrganizationMembers: Array<WithTypename<InvitedUser>> }, QueryInvitedOrganizationMembersArgs>,
    me?: GraphCacheUpdateResolver<{ me: WithTypename<User> }, Record<string, never>>,
    myShortcodes?: GraphCacheUpdateResolver<{ myShortcodes: Array<WithTypename<Shortcode>> }, QueryMyShortcodesArgs>,
    myTeams?: GraphCacheUpdateResolver<{ myTeams: Array<WithTypename<Team>> }, QueryMyTeamsArgs>,
    organization?: GraphCacheUpdateResolver<{ organization: WithTypename<Organization> }, QueryOrganizationArgs>,
    organizationByDomain?: GraphCacheUpdateResolver<{ organizationByDomain: Scalars['String'] }, QueryOrganizationByDomainArgs>,
    organizationMember?: GraphCacheUpdateResolver<{ organizationMember: WithTypename<OrganizationMember> }, QueryOrganizationMemberArgs>,
    organizationMembers?: GraphCacheUpdateResolver<{ organizationMembers: Array<WithTypename<OrganizationMember>> }, QueryOrganizationMembersArgs>,
    organizationMembersCount?: GraphCacheUpdateResolver<{ organizationMembersCount: Scalars['Float'] }, QueryOrganizationMembersCountArgs>,
    organizationTeamCollectionsCount?: GraphCacheUpdateResolver<{ organizationTeamCollectionsCount: Scalars['Float'] }, QueryOrganizationTeamCollectionsCountArgs>,
    organizationTeamInfo?: GraphCacheUpdateResolver<{ organizationTeamInfo: WithTypename<Team> }, QueryOrganizationTeamInfoArgs>,
    organizationTeamRequestsCount?: GraphCacheUpdateResolver<{ organizationTeamRequestsCount: Scalars['Float'] }, QueryOrganizationTeamRequestsCountArgs>,
    organizationTeams?: GraphCacheUpdateResolver<{ organizationTeams: Array<WithTypename<Team>> }, QueryOrganizationTeamsArgs>,
    organizationTeamsCount?: GraphCacheUpdateResolver<{ organizationTeamsCount: Scalars['Float'] }, QueryOrganizationTeamsCountArgs>,
    request?: GraphCacheUpdateResolver<{ request: Maybe<WithTypename<TeamRequest>> }, QueryRequestArgs>,
    requestsInCollection?: GraphCacheUpdateResolver<{ requestsInCollection: Array<WithTypename<TeamRequest>> }, QueryRequestsInCollectionArgs>,
    rootCollectionsOfTeam?: GraphCacheUpdateResolver<{ rootCollectionsOfTeam: Array<WithTypename<TeamCollection>> }, QueryRootCollectionsOfTeamArgs>,
    searchForRequest?: GraphCacheUpdateResolver<{ searchForRequest: Array<WithTypename<TeamRequest>> }, QuerySearchForRequestArgs>,
    shortcode?: GraphCacheUpdateResolver<{ shortcode: Maybe<WithTypename<Shortcode>> }, QueryShortcodeArgs>,
    team?: GraphCacheUpdateResolver<{ team: Maybe<WithTypename<Team>> }, QueryTeamArgs>,
    teamInvitation?: GraphCacheUpdateResolver<{ teamInvitation: WithTypename<TeamInvitation> }, QueryTeamInvitationArgs>,
    user?: GraphCacheUpdateResolver<{ user: Maybe<WithTypename<User>> }, QueryUserArgs>
  },
  Mutation?: {
    acceptOrganizationInvitation?: GraphCacheUpdateResolver<{ acceptOrganizationInvitation: WithTypename<OrganizationMember> }, MutationAcceptOrganizationInvitationArgs>,
    acceptTeamInvitation?: GraphCacheUpdateResolver<{ acceptTeamInvitation: WithTypename<TeamMember> }, MutationAcceptTeamInvitationArgs>,
    addOrganizationMember?: GraphCacheUpdateResolver<{ addOrganizationMember: WithTypename<OrganizationMember> }, MutationAddOrganizationMemberArgs>,
    addTeamMemberByEmail?: GraphCacheUpdateResolver<{ addTeamMemberByEmail: WithTypename<TeamMember> }, MutationAddTeamMemberByEmailArgs>,
    addUserToTeamByAdmin?: GraphCacheUpdateResolver<{ addUserToTeamByAdmin: WithTypename<TeamMember> }, MutationAddUserToTeamByAdminArgs>,
    cancelOrganizationSubscription?: GraphCacheUpdateResolver<{ cancelOrganizationSubscription: Scalars['Boolean'] }, MutationCancelOrganizationSubscriptionArgs>,
    createChildCollection?: GraphCacheUpdateResolver<{ createChildCollection: WithTypename<TeamCollection> }, MutationCreateChildCollectionArgs>,
    createDuplicateEnvironment?: GraphCacheUpdateResolver<{ createDuplicateEnvironment: WithTypename<TeamEnvironment> }, MutationCreateDuplicateEnvironmentArgs>,
    createRequestInCollection?: GraphCacheUpdateResolver<{ createRequestInCollection: WithTypename<TeamRequest> }, MutationCreateRequestInCollectionArgs>,
    createRootCollection?: GraphCacheUpdateResolver<{ createRootCollection: WithTypename<TeamCollection> }, MutationCreateRootCollectionArgs>,
    createShortcode?: GraphCacheUpdateResolver<{ createShortcode: WithTypename<Shortcode> }, MutationCreateShortcodeArgs>,
    createTeam?: GraphCacheUpdateResolver<{ createTeam: WithTypename<Team> }, MutationCreateTeamArgs>,
    createTeamByAdmin?: GraphCacheUpdateResolver<{ createTeamByAdmin: WithTypename<Team> }, MutationCreateTeamByAdminArgs>,
    createTeamEnvironment?: GraphCacheUpdateResolver<{ createTeamEnvironment: WithTypename<TeamEnvironment> }, MutationCreateTeamEnvironmentArgs>,
    createTeamInvitation?: GraphCacheUpdateResolver<{ createTeamInvitation: WithTypename<TeamInvitation> }, MutationCreateTeamInvitationArgs>,
    deactivateOrganizationMember?: GraphCacheUpdateResolver<{ deactivateOrganizationMember: Scalars['Boolean'] }, MutationDeactivateOrganizationMemberArgs>,
    deleteAllVariablesFromTeamEnvironment?: GraphCacheUpdateResolver<{ deleteAllVariablesFromTeamEnvironment: WithTypename<TeamEnvironment> }, MutationDeleteAllVariablesFromTeamEnvironmentArgs>,
    deleteCollection?: GraphCacheUpdateResolver<{ deleteCollection: Scalars['Boolean'] }, MutationDeleteCollectionArgs>,
    deleteRequest?: GraphCacheUpdateResolver<{ deleteRequest: Scalars['Boolean'] }, MutationDeleteRequestArgs>,
    deleteTeam?: GraphCacheUpdateResolver<{ deleteTeam: Scalars['Boolean'] }, MutationDeleteTeamArgs>,
    deleteTeamByAdmin?: GraphCacheUpdateResolver<{ deleteTeamByAdmin: Scalars['Boolean'] }, MutationDeleteTeamByAdminArgs>,
    deleteTeamEnvironment?: GraphCacheUpdateResolver<{ deleteTeamEnvironment: Scalars['Boolean'] }, MutationDeleteTeamEnvironmentArgs>,
    deleteUser?: GraphCacheUpdateResolver<{ deleteUser: Scalars['Boolean'] }, Record<string, never>>,
    demoteOrganizationMembersAsAdmin?: GraphCacheUpdateResolver<{ demoteOrganizationMembersAsAdmin: Scalars['Boolean'] }, MutationDemoteOrganizationMembersAsAdminArgs>,
    duplicateTeamCollection?: GraphCacheUpdateResolver<{ duplicateTeamCollection: Scalars['Boolean'] }, MutationDuplicateTeamCollectionArgs>,
    importCollectionFromUserFirestore?: GraphCacheUpdateResolver<{ importCollectionFromUserFirestore: WithTypename<TeamCollection> }, MutationImportCollectionFromUserFirestoreArgs>,
    importCollectionsFromJSON?: GraphCacheUpdateResolver<{ importCollectionsFromJSON: Scalars['Boolean'] }, MutationImportCollectionsFromJsonArgs>,
    initiateOrganizationPurchase?: GraphCacheUpdateResolver<{ initiateOrganizationPurchase: Scalars['String'] }, MutationInitiateOrganizationPurchaseArgs>,
    inviteNewUser?: GraphCacheUpdateResolver<{ inviteNewUser: WithTypename<InvitedUser> }, MutationInviteNewUserArgs>,
    leaveTeam?: GraphCacheUpdateResolver<{ leaveTeam: Scalars['Boolean'] }, MutationLeaveTeamArgs>,
    makeOrganizationMemberAnAdmin?: GraphCacheUpdateResolver<{ makeOrganizationMemberAnAdmin: WithTypename<OrganizationMember> }, MutationMakeOrganizationMemberAnAdminArgs>,
    makeOrganizationMembersAdmin?: GraphCacheUpdateResolver<{ makeOrganizationMembersAdmin: Scalars['Boolean'] }, MutationMakeOrganizationMembersAdminArgs>,
    moveCollection?: GraphCacheUpdateResolver<{ moveCollection: WithTypename<TeamCollection> }, MutationMoveCollectionArgs>,
    moveRequest?: GraphCacheUpdateResolver<{ moveRequest: WithTypename<TeamRequest> }, MutationMoveRequestArgs>,
    removeMemberFromTeamByAdmin?: GraphCacheUpdateResolver<{ removeMemberFromTeamByAdmin: Scalars['Boolean'] }, MutationRemoveMemberFromTeamByAdminArgs>,
    removeOrganizationMember?: GraphCacheUpdateResolver<{ removeOrganizationMember: WithTypename<OrganizationMember> }, MutationRemoveOrganizationMemberArgs>,
    removeTeamMember?: GraphCacheUpdateResolver<{ removeTeamMember: Scalars['Boolean'] }, MutationRemoveTeamMemberArgs>,
    renameCollection?: GraphCacheUpdateResolver<{ renameCollection: WithTypename<TeamCollection> }, MutationRenameCollectionArgs>,
    renameTeam?: GraphCacheUpdateResolver<{ renameTeam: WithTypename<Team> }, MutationRenameTeamArgs>,
    renameTeamByAdmin?: GraphCacheUpdateResolver<{ renameTeamByAdmin: WithTypename<Team> }, MutationRenameTeamByAdminArgs>,
    replaceCollectionsWithJSON?: GraphCacheUpdateResolver<{ replaceCollectionsWithJSON: Scalars['Boolean'] }, MutationReplaceCollectionsWithJsonArgs>,
    revokeOrganizationMemberAdminAccess?: GraphCacheUpdateResolver<{ revokeOrganizationMemberAdminAccess: WithTypename<OrganizationMember> }, MutationRevokeOrganizationMemberAdminAccessArgs>,
    revokeOrganizationMemberInvitationsByAdmin?: GraphCacheUpdateResolver<{ revokeOrganizationMemberInvitationsByAdmin: Scalars['Boolean'] }, MutationRevokeOrganizationMemberInvitationsByAdminArgs>,
    revokeOrganizationTeamInviteByAdmin?: GraphCacheUpdateResolver<{ revokeOrganizationTeamInviteByAdmin: Scalars['Boolean'] }, MutationRevokeOrganizationTeamInviteByAdminArgs>,
    revokeShortcode?: GraphCacheUpdateResolver<{ revokeShortcode: Scalars['Boolean'] }, MutationRevokeShortcodeArgs>,
    revokeTeamInvitation?: GraphCacheUpdateResolver<{ revokeTeamInvitation: Scalars['Boolean'] }, MutationRevokeTeamInvitationArgs>,
    updateCollectionOrder?: GraphCacheUpdateResolver<{ updateCollectionOrder: Scalars['Boolean'] }, MutationUpdateCollectionOrderArgs>,
    updateEmbedProperties?: GraphCacheUpdateResolver<{ updateEmbedProperties: WithTypename<Shortcode> }, MutationUpdateEmbedPropertiesArgs>,
    updateLookUpRequestOrder?: GraphCacheUpdateResolver<{ updateLookUpRequestOrder: Scalars['Boolean'] }, MutationUpdateLookUpRequestOrderArgs>,
    updateOrganizationBillingCycle?: GraphCacheUpdateResolver<{ updateOrganizationBillingCycle: Scalars['Boolean'] }, MutationUpdateOrganizationBillingCycleArgs>,
    updateOrganizationSeats?: GraphCacheUpdateResolver<{ updateOrganizationSeats: Scalars['Boolean'] }, MutationUpdateOrganizationSeatsArgs>,
    updateOrganizationTeamMemberRoleByAdmin?: GraphCacheUpdateResolver<{ updateOrganizationTeamMemberRoleByAdmin: WithTypename<TeamMember> }, MutationUpdateOrganizationTeamMemberRoleByAdminArgs>,
    updateRequest?: GraphCacheUpdateResolver<{ updateRequest: WithTypename<TeamRequest> }, MutationUpdateRequestArgs>,
    updateTeamCollection?: GraphCacheUpdateResolver<{ updateTeamCollection: WithTypename<TeamCollection> }, MutationUpdateTeamCollectionArgs>,
    updateTeamEnvironment?: GraphCacheUpdateResolver<{ updateTeamEnvironment: WithTypename<TeamEnvironment> }, MutationUpdateTeamEnvironmentArgs>,
    updateTeamMemberRole?: GraphCacheUpdateResolver<{ updateTeamMemberRole: WithTypename<TeamMember> }, MutationUpdateTeamMemberRoleArgs>
  },
  Subscription?: {
    collectionOrderUpdated?: GraphCacheUpdateResolver<{ collectionOrderUpdated: WithTypename<CollectionReorderData> }, SubscriptionCollectionOrderUpdatedArgs>,
    myShortcodesCreated?: GraphCacheUpdateResolver<{ myShortcodesCreated: WithTypename<Shortcode> }, Record<string, never>>,
    myShortcodesRevoked?: GraphCacheUpdateResolver<{ myShortcodesRevoked: WithTypename<Shortcode> }, Record<string, never>>,
    myShortcodesUpdated?: GraphCacheUpdateResolver<{ myShortcodesUpdated: WithTypename<Shortcode> }, Record<string, never>>,
    organizationCreated?: GraphCacheUpdateResolver<{ organizationCreated: Scalars['String'] }, Record<string, never>>,
    organizationMemberAdded?: GraphCacheUpdateResolver<{ organizationMemberAdded: WithTypename<OrganizationMember> }, SubscriptionOrganizationMemberAddedArgs>,
    organizationMemberRemoved?: GraphCacheUpdateResolver<{ organizationMemberRemoved: WithTypename<OrganizationMember> }, SubscriptionOrganizationMemberRemovedArgs>,
    requestMoved?: GraphCacheUpdateResolver<{ requestMoved: WithTypename<TeamRequest> }, SubscriptionRequestMovedArgs>,
    requestOrderUpdated?: GraphCacheUpdateResolver<{ requestOrderUpdated: WithTypename<RequestReorderData> }, SubscriptionRequestOrderUpdatedArgs>,
    teamCollectionAdded?: GraphCacheUpdateResolver<{ teamCollectionAdded: WithTypename<TeamCollection> }, SubscriptionTeamCollectionAddedArgs>,
    teamCollectionMoved?: GraphCacheUpdateResolver<{ teamCollectionMoved: WithTypename<TeamCollection> }, SubscriptionTeamCollectionMovedArgs>,
    teamCollectionRemoved?: GraphCacheUpdateResolver<{ teamCollectionRemoved: Scalars['ID'] }, SubscriptionTeamCollectionRemovedArgs>,
    teamCollectionUpdated?: GraphCacheUpdateResolver<{ teamCollectionUpdated: WithTypename<TeamCollection> }, SubscriptionTeamCollectionUpdatedArgs>,
    teamEnvironmentCreated?: GraphCacheUpdateResolver<{ teamEnvironmentCreated: WithTypename<TeamEnvironment> }, SubscriptionTeamEnvironmentCreatedArgs>,
    teamEnvironmentDeleted?: GraphCacheUpdateResolver<{ teamEnvironmentDeleted: WithTypename<TeamEnvironment> }, SubscriptionTeamEnvironmentDeletedArgs>,
    teamEnvironmentUpdated?: GraphCacheUpdateResolver<{ teamEnvironmentUpdated: WithTypename<TeamEnvironment> }, SubscriptionTeamEnvironmentUpdatedArgs>,
    teamInvitationAdded?: GraphCacheUpdateResolver<{ teamInvitationAdded: WithTypename<TeamInvitation> }, SubscriptionTeamInvitationAddedArgs>,
    teamInvitationRemoved?: GraphCacheUpdateResolver<{ teamInvitationRemoved: Scalars['ID'] }, SubscriptionTeamInvitationRemovedArgs>,
    teamMemberAdded?: GraphCacheUpdateResolver<{ teamMemberAdded: WithTypename<TeamMember> }, SubscriptionTeamMemberAddedArgs>,
    teamMemberRemoved?: GraphCacheUpdateResolver<{ teamMemberRemoved: Scalars['ID'] }, SubscriptionTeamMemberRemovedArgs>,
    teamMemberUpdated?: GraphCacheUpdateResolver<{ teamMemberUpdated: WithTypename<TeamMember> }, SubscriptionTeamMemberUpdatedArgs>,
    teamRequestAdded?: GraphCacheUpdateResolver<{ teamRequestAdded: WithTypename<TeamRequest> }, SubscriptionTeamRequestAddedArgs>,
    teamRequestDeleted?: GraphCacheUpdateResolver<{ teamRequestDeleted: Scalars['ID'] }, SubscriptionTeamRequestDeletedArgs>,
    teamRequestUpdated?: GraphCacheUpdateResolver<{ teamRequestUpdated: WithTypename<TeamRequest> }, SubscriptionTeamRequestUpdatedArgs>,
    userDeleted?: GraphCacheUpdateResolver<{ userDeleted: WithTypename<User> }, Record<string, never>>,
    userInvited?: GraphCacheUpdateResolver<{ userInvited: WithTypename<InvitedUser> }, Record<string, never>>
  },
  CollectionReorderData?: {
    collection?: GraphCacheUpdateResolver<Maybe<WithTypename<CollectionReorderData>>, Record<string, never>>,
    nextCollection?: GraphCacheUpdateResolver<Maybe<WithTypename<CollectionReorderData>>, Record<string, never>>
  },
  InvitedUser?: {
    adminEmail?: GraphCacheUpdateResolver<Maybe<WithTypename<InvitedUser>>, Record<string, never>>,
    adminName?: GraphCacheUpdateResolver<Maybe<WithTypename<InvitedUser>>, Record<string, never>>,
    adminUid?: GraphCacheUpdateResolver<Maybe<WithTypename<InvitedUser>>, Record<string, never>>,
    inviteID?: GraphCacheUpdateResolver<Maybe<WithTypename<InvitedUser>>, Record<string, never>>,
    invitedOn?: GraphCacheUpdateResolver<Maybe<WithTypename<InvitedUser>>, Record<string, never>>,
    inviteeEmail?: GraphCacheUpdateResolver<Maybe<WithTypename<InvitedUser>>, Record<string, never>>,
    orgID?: GraphCacheUpdateResolver<Maybe<WithTypename<InvitedUser>>, Record<string, never>>,
    orgName?: GraphCacheUpdateResolver<Maybe<WithTypename<InvitedUser>>, Record<string, never>>
  },
  Organization?: {
    billingAddress?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>,
    billingCycle?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>,
    billingEmail?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>,
    checkoutUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>,
    createdOn?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>,
    nextBillingDate?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>,
    orgDomain?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>,
    orgID?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>,
    orgMetadata?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>,
    orgName?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>,
    orgStatus?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>,
    seats?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>
  },
  OrganizationBillingAddress?: {
    city?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationBillingAddress>>, Record<string, never>>,
    country?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationBillingAddress>>, Record<string, never>>,
    line1?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationBillingAddress>>, Record<string, never>>,
    line2?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationBillingAddress>>, Record<string, never>>,
    postal_code?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationBillingAddress>>, Record<string, never>>,
    state?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationBillingAddress>>, Record<string, never>>
  },
  OrganizationMember?: {
    createdOn?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationMember>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationMember>>, Record<string, never>>,
    invitedOn?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationMember>>, Record<string, never>>,
    inviteeUserUID?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationMember>>, Record<string, never>>,
    isAdmin?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationMember>>, Record<string, never>>,
    lastActiveOn?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationMember>>, Record<string, never>>,
    membershipStatus?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationMember>>, Record<string, never>>,
    orgID?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationMember>>, Record<string, never>>,
    photoURL?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationMember>>, Record<string, never>>,
    userEmail?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationMember>>, Record<string, never>>,
    userName?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationMember>>, Record<string, never>>,
    userUID?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationMember>>, Record<string, never>>
  },
  RequestReorderData?: {
    nextRequest?: GraphCacheUpdateResolver<Maybe<WithTypename<RequestReorderData>>, Record<string, never>>,
    request?: GraphCacheUpdateResolver<Maybe<WithTypename<RequestReorderData>>, Record<string, never>>
  },
  Shortcode?: {
    createdOn?: GraphCacheUpdateResolver<Maybe<WithTypename<Shortcode>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Shortcode>>, Record<string, never>>,
    orgID?: GraphCacheUpdateResolver<Maybe<WithTypename<Shortcode>>, Record<string, never>>,
    properties?: GraphCacheUpdateResolver<Maybe<WithTypename<Shortcode>>, Record<string, never>>,
    request?: GraphCacheUpdateResolver<Maybe<WithTypename<Shortcode>>, Record<string, never>>
  },
  Team?: {
    editorsCount?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, Record<string, never>>,
    members?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, TeamMembersArgs>,
    myRole?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, Record<string, never>>,
    orgDomain?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, Record<string, never>>,
    orgID?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, Record<string, never>>,
    orgName?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, Record<string, never>>,
    ownersCount?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, Record<string, never>>,
    teamEnvironments?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, Record<string, never>>,
    teamInvitations?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, Record<string, never>>,
    teamMembers?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, Record<string, never>>,
    viewersCount?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, Record<string, never>>
  },
  TeamCollection?: {
    children?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamCollection>>, TeamCollectionChildrenArgs>,
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamCollection>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamCollection>>, Record<string, never>>,
    parent?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamCollection>>, Record<string, never>>,
    team?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamCollection>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamCollection>>, Record<string, never>>
  },
  TeamEnvironment?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamEnvironment>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamEnvironment>>, Record<string, never>>,
    teamID?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamEnvironment>>, Record<string, never>>,
    variables?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamEnvironment>>, Record<string, never>>
  },
  TeamInvitation?: {
    creator?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamInvitation>>, Record<string, never>>,
    creatorUid?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamInvitation>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamInvitation>>, Record<string, never>>,
    inviteeEmail?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamInvitation>>, Record<string, never>>,
    inviteeRole?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamInvitation>>, Record<string, never>>,
    team?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamInvitation>>, Record<string, never>>,
    teamID?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamInvitation>>, Record<string, never>>
  },
  TeamMember?: {
    membershipID?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamMember>>, Record<string, never>>,
    role?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamMember>>, Record<string, never>>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamMember>>, Record<string, never>>
  },
  TeamRequest?: {
    collection?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamRequest>>, Record<string, never>>,
    collectionID?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamRequest>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamRequest>>, Record<string, never>>,
    request?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamRequest>>, Record<string, never>>,
    team?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamRequest>>, Record<string, never>>,
    teamID?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamRequest>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamRequest>>, Record<string, never>>
  },
  User?: {
    displayName?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    email?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    photoURL?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    uid?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>
  },
};

export type GraphCacheConfig = Parameters<typeof cacheExchange>[0] & {
  updates?: GraphCacheUpdaters,
  keys?: GraphCacheKeysConfig,
  optimistic?: GraphCacheOptimisticUpdaters,
  resolvers?: GraphCacheResolvers,
};